import { StringUtil as fe, callService as oe, validMimeType as xe, ImageFileType as _, getImageSize as we, dialCodes as k, charityCountries as ve, otherCountries as Ce, savePDF as Ne } from "@lib/services";
import { HttpRequestMethod as U, HttpStatus as ke } from "http-core-constants";
import Le from "dompurify";
import { jsx as t, Fragment as j, jsxs as s } from "react/jsx-runtime";
import { useForm as re } from "react-hook-form";
import { useMutation as ne } from "react-query";
import Me from "email-validator";
import { useAuth as O, UnauthorizedError as J } from "@lib/hooks";
import { ComponentsTestId as x } from "@lib/testing";
import * as R from "react";
import { useEffect as S, useState as M, forwardRef as Se, useMemo as ze } from "react";
import { Link as Be, useLocation as ae } from "react-router-dom";
import { usePathname as Te } from "next/navigation";
import X from "react-bootstrap/Button";
import I from "react-bootstrap/Modal";
import { Elements as Ae } from "@stripe/react-stripe-js";
function Q(e) {
  if (!fe.isEmpty(e))
    return Ie(e);
}
function Ie(e) {
  const r = "", n = new File([r], e, { type: "image/jpeg" }), o = new DataTransfer();
  return o.items.add(n), o.files.isFake = !0, o.files;
}
function P(e) {
  return e.size === 0;
}
const ft = async (e, r) => oe(`/api/charity/${e}/tax_receipts`, U.PUT, r), Ee = async (e) => oe(`/api/charity/${e}/tax_receipts/images_upload`, U.GET), K = async (e, r) => {
  if (!xe.includes(e.type))
    throw new Error("Invalid file type, please upload one of the following valid file type; png, jpg or svg");
  e.type === _.svg && (e = await $e(e));
  const n = await e.arrayBuffer(), o = await fetch(r, {
    method: U.PUT,
    body: n,
    headers: {
      "content-type": e.type
    }
  });
  if (o.status !== ke.OK)
    throw new Error(`Unexpected status ${o.status} body:${await o.text()}`);
}, $e = async (e) => new Promise((r, n) => {
  const o = new FileReader();
  o.onload = (a) => {
    var c;
    try {
      const i = (c = a.target) == null ? void 0 : c.result, d = Le.sanitize(i, { USE_PROFILES: { svg: !0 } }), l = new Blob([d], { type: _.svg }), u = new File([l], e.name, { type: _.svg });
      r(u);
    } catch (i) {
      n(i);
    }
  }, o.onerror = (a) => {
    n(a);
  }, o.readAsText(e);
}), Pe = (e) => {
  const r = e.split(","), n = r[0].match(/:(.*?);/)[1], o = atob(r[1]);
  let a = o.length;
  const c = new Uint8Array(a);
  for (; a--; )
    c[a] = o.charCodeAt(a);
  return new Blob([c], { type: n });
}, xt = async (e, r, n) => {
  const o = new File([Pe(e)], n, { type: _.jpg });
  await K(o, r);
}, Fe = async (e, r, n) => {
  if (P(r) && P(n))
    return;
  const o = await Ee(e);
  P(r) || await K(r, o.logo_url), P(n) || await K(n, o.signature_url);
}, Re = async (e, r) => await (await fetch(`/api/charity/${e}/tax_receipts/preview`, {
  method: U.POST,
  body: JSON.stringify(r)
})).text();
var D;
((e) => {
  const o = /[!@#$%^&*()_+\-=[\]{};:"\\|,<>/?~]/, a = "Sorry! We aren't able to accept this email address";
  e.validateEmail = (i) => Me.validate(i) ? !0 : a, e.validateLastName = (i) => i === void 0 ? "Please enter last name" : i.trim().length < 2 ? "Last name should contain at least 2 characters" : o.test(i) ? "Last name can't contain special characters" : !0, e.validateFirstName = (i) => i === void 0 ? "Please enter first name" : i.trim().length < 1 ? "First name can't be empty" : o.test(i) ? "First name can't contain special characters" : !0, e.validatePhoneNumber = (i) => {
    if (i === void 0 || i === "")
      return !0;
    const l = i.match(/^[0-9\- ()]*$/) !== null, u = (i.match(/\d/g) ?? []).length;
    return u < 6 ? "The phone number you entered is too short" : u > 12 ? "The phone number you entered is too long" : l ? !0 : "Sorry! We aren't able to accept this phone number";
  };
  async function c(i, d, l) {
    let u = !0;
    const g = i[0];
    if (g) {
      const m = await we(g);
      l ? (d.width < m.width || d.height < m.height) && (u = `Please select an image with size less or equal to ${d.width}X${d.height}. Your current image is: ${m.width}X${m.height}`) : (d.width !== m.width || d.height !== m.height) && (u = `Please select an image of size ${d.width}X${d.height}`);
    }
    return u;
  }
  e.validateImageSize = c;
})(D || (D = {}));
const wt = [
  { country: "United Kingdom", code: "+44", iso: "GB" },
  { country: "United States", code: "+1", iso: "US" },
  { country: "Canada", code: "+1", iso: "CA" },
  { country: "Australia", code: "+61", iso: "AU" },
  { country: "Afghanistan", code: "+93", iso: "AF" },
  { country: "Albania", code: "+355", iso: "AL" },
  { country: "Algeria", code: "+213", iso: "DZ" },
  { country: "American Samoa", code: "+1 (684)", iso: "AS" },
  { country: "Andorra", code: "+376", iso: "AD" },
  { country: "Angola", code: "+244", iso: "AO" },
  { country: "Anguilla", code: "+1 (264)", iso: "AI" },
  { country: "Antarctica", code: "+672", iso: "AQ" },
  { country: "Antigua and Barbuda", code: "+1 (268)", iso: "AG" },
  { country: "Argentina", code: "+54", iso: "AR" },
  { country: "Armenia", code: "+374", iso: "AM" },
  { country: "Aruba", code: "+297", iso: "AW" },
  { country: "Austria", code: "+43", iso: "AT" },
  { country: "Azerbaijan", code: "+994", iso: "AZ" },
  { country: "Bahamas", code: "+1 (242)", iso: "BS" },
  { country: "Bahrain", code: "+973", iso: "BH" },
  { country: "Bangladesh", code: "+880", iso: "BD" },
  { country: "Barbados", code: "+1 (246)", iso: "BB" },
  { country: "Belarus", code: "+375", iso: "BY" },
  { country: "Belgium", code: "+32", iso: "BE" },
  { country: "Belize", code: "+501", iso: "BZ" },
  { country: "Benin", code: "+229", iso: "BJ" },
  { country: "Bermuda", code: "+1 (441)", iso: "BM" },
  { country: "Bhutan", code: "+975", iso: "BT" },
  { country: "Bolivia", code: "+591", iso: "BO" },
  { country: "Bosnia and Herzegovina", code: "+387", iso: "BA" },
  { country: "Botswana", code: "+267", iso: "BW" },
  { country: "Brazil", code: "+55", iso: "BR" },
  { country: "British Indian Ocean Territory", code: "+246", iso: "IO" },
  { country: "British Virgin Islands", code: "+1 (284)", iso: "VG" },
  { country: "Brunei", code: "+673", iso: "BN" },
  { country: "Bulgaria", code: "+359", iso: "BG" },
  { country: "Burkina Faso", code: "+226", iso: "BF" },
  { country: "Burundi", code: "+257", iso: "BI" },
  { country: "Cambodia", code: "+855", iso: "KH" },
  { country: "Cameroon", code: "+237", iso: "CM" },
  { country: "Cape Verde", code: "+238", iso: "CV" },
  { country: "Cayman Islands", code: "+1 (345)", iso: "KY" },
  { country: "Central African Republic", code: "+236", iso: "CF" },
  { country: "Chad", code: "+235", iso: "TD" },
  { country: "Chile", code: "+56", iso: "CL" },
  { country: "China", code: "+86", iso: "CN" },
  { country: "Christmas Island", code: "+61", iso: "CX" },
  { country: "Cocos Islands", code: "+61", iso: "CC" },
  { country: "Colombia", code: "+57", iso: "CO" },
  { country: "Comoros", code: "+269", iso: "KM" },
  { country: "Cook Islands", code: "+682", iso: "CK" },
  { country: "Costa Rica", code: "+506", iso: "CR" },
  { country: "Croatia", code: "+385", iso: "HR" },
  { country: "Cuba", code: "+53", iso: "CU" },
  { country: "Curacao", code: "+599", iso: "CW" },
  { country: "Cyprus", code: "+357", iso: "CY" },
  { country: "Czech Republic", code: "+420", iso: "CZ" },
  { country: "Democratic Republic of the Congo", code: "+243", iso: "CD" },
  { country: "Denmark", code: "+45", iso: "DK" },
  { country: "Djibouti", code: "+253", iso: "DJ" },
  { country: "Dominica", code: "+1 (767)", iso: "DM" },
  { country: "Dominican Republic", code: "+1 (809), +1 (829), +1 (849)", iso: "DO" },
  { country: "East Timor", code: "+670", iso: "TL" },
  { country: "Ecuador", code: "+593", iso: "EC" },
  { country: "Egypt", code: "+20", iso: "EG" },
  { country: "El Salvador", code: "+503", iso: "SV" },
  { country: "Equatorial Guinea", code: "+240", iso: "GQ" },
  { country: "Eritrea", code: "+291", iso: "ER" },
  { country: "Estonia", code: "+372", iso: "EE" },
  { country: "Ethiopia", code: "+251", iso: "ET" },
  { country: "Falkland Islands", code: "+500", iso: "FK" },
  { country: "Faroe Islands", code: "+298", iso: "FO" },
  { country: "Fiji", code: "+679", iso: "FJ" },
  { country: "Finland", code: "+358", iso: "FI" },
  { country: "France", code: "+33", iso: "FR" },
  { country: "French Polynesia", code: "+689", iso: "PF" },
  { country: "Gabon", code: "+241", iso: "GA" },
  { country: "Gambia", code: "+220", iso: "GM" },
  { country: "Georgia", code: "+995", iso: "GE" },
  { country: "Germany", code: "+49", iso: "DE" },
  { country: "Ghana", code: "+233", iso: "GH" },
  { country: "Gibraltar", code: "+350", iso: "GI" },
  { country: "Greece", code: "+30", iso: "GR" },
  { country: "Greenland", code: "+299", iso: "GL" },
  { country: "Grenada", code: "+1 (473)", iso: "GD" },
  { country: "Guam", code: "+1 (671)", iso: "GU" },
  { country: "Guatemala", code: "+502", iso: "GT" },
  { country: "Guernsey", code: "+44 (1481)", iso: "GG" },
  { country: "Guinea", code: "+224", iso: "GN" },
  { country: "Guinea-Bissau", code: "+245", iso: "GW" },
  { country: "Guyana", code: "+592", iso: "GY" },
  { country: "Haiti", code: "+509", iso: "HT" },
  { country: "Honduras", code: "+504", iso: "HN" },
  { country: "Hong Kong", code: "+852", iso: "HK" },
  { country: "Hungary", code: "+36", iso: "HU" },
  { country: "Iceland", code: "+354", iso: "IS" },
  { country: "India", code: "+91", iso: "IN" },
  { country: "Indonesia", code: "+62", iso: "ID" },
  { country: "Iran", code: "+98", iso: "IR" },
  { country: "Iraq", code: "+964", iso: "IQ" },
  { country: "Ireland", code: "+353", iso: "IE" },
  { country: "Isle of Man", code: "+44 (1624)", iso: "IM" },
  { country: "Israel", code: "+972", iso: "IL" },
  { country: "Italy", code: "+39", iso: "IT" },
  { country: "Ivory Coast", code: "+225", iso: "CI" },
  { country: "Jamaica", code: "+1 (876)", iso: "JM" },
  { country: "Japan", code: "+81", iso: "JP" },
  { country: "Jersey", code: "+44 (1534)", iso: "JE" },
  { country: "Jordan", code: "+962", iso: "JO" },
  { country: "Kazakhstan", code: "+7", iso: "KZ" },
  { country: "Kenya", code: "+254", iso: "KE" },
  { country: "Kiribati", code: "+686", iso: "KI" },
  { country: "Kosovo", code: "+383", iso: "XK" },
  { country: "Kuwait", code: "+965", iso: "KW" },
  { country: "Kyrgyzstan", code: "+996", iso: "KG" },
  { country: "Laos", code: "+856", iso: "LA" },
  { country: "Latvia", code: "+371", iso: "LV" },
  { country: "Lebanon", code: "+961", iso: "LB" },
  { country: "Lesotho", code: "+266", iso: "LS" },
  { country: "Liberia", code: "+231", iso: "LR" },
  { country: "Libya", code: "+218", iso: "LY" },
  { country: "Liechtenstein", code: "+423", iso: "LI" },
  { country: "Lithuania", code: "+370", iso: "LT" },
  { country: "Luxembourg", code: "+352", iso: "LU" },
  { country: "Macao", code: "+853", iso: "MO" },
  { country: "Macedonia", code: "+389", iso: "MK" },
  { country: "Madagascar", code: "+261", iso: "MG" },
  { country: "Malawi", code: "+265", iso: "MW" },
  { country: "Malaysia", code: "+60", iso: "MY" },
  { country: "Maldives", code: "+960", iso: "MV" },
  { country: "Mali", code: "+223", iso: "ML" },
  { country: "Malta", code: "+356", iso: "MT" },
  { country: "Marshall Islands", code: "+692", iso: "MH" },
  { country: "Mauritania", code: "+222", iso: "MR" },
  { country: "Mauritius", code: "+230", iso: "MU" },
  { country: "Mayotte", code: "+262", iso: "YT" },
  { country: "Mexico", code: "+52", iso: "MX" },
  { country: "Micronesia", code: "+691", iso: "FM" },
  { country: "Moldova", code: "+373", iso: "MD" },
  { country: "Monaco", code: "+377", iso: "MC" },
  { country: "Mongolia", code: "+976", iso: "MN" },
  { country: "Montenegro", code: "+382", iso: "ME" },
  { country: "Montserrat", code: "+1 (664)", iso: "MS" },
  { country: "Morocco", code: "+212", iso: "MA" },
  { country: "Mozambique", code: "+258", iso: "MZ" },
  { country: "Myanmar", code: "+95", iso: "MM" },
  { country: "Namibia", code: "+264", iso: "NA" },
  { country: "Nauru", code: "+674", iso: "NR" },
  { country: "Nepal", code: "+977", iso: "NP" },
  { country: "Netherlands", code: "+31", iso: "NL" },
  { country: "Netherlands Antilles", code: "+599", iso: "AN" },
  { country: "New Caledonia", code: "+687", iso: "NC" },
  { country: "New Zealand", code: "+64", iso: "NZ" },
  { country: "Nicaragua", code: "+505", iso: "NI" },
  { country: "Niger", code: "+227", iso: "NE" },
  { country: "Nigeria", code: "+234", iso: "NG" },
  { country: "Niue", code: "+683", iso: "NU" },
  { country: "North Korea", code: "+850", iso: "KP" },
  { country: "Northern Mariana Islands", code: "+1 (670)", iso: "MP" },
  { country: "Norway", code: "+47", iso: "NO" },
  { country: "Oman", code: "+968", iso: "OM" },
  { country: "Pakistan", code: "+92", iso: "PK" },
  { country: "Palau", code: "+680", iso: "PW" },
  { country: "Palestine", code: "+970", iso: "PS" },
  { country: "Panama", code: "+507", iso: "PA" },
  { country: "Papua New Guinea", code: "+675", iso: "PG" },
  { country: "Paraguay", code: "+595", iso: "PY" },
  { country: "Peru", code: "+51", iso: "PE" },
  { country: "Philippines", code: "+63", iso: "PH" },
  { country: "Pitcairn", code: "+64", iso: "PN" },
  { country: "Poland", code: "+48", iso: "PL" },
  { country: "Portugal", code: "+351", iso: "PT" },
  { country: "Puerto Rico", code: "+1 (787), 1 (939)", iso: "PR" },
  { country: "Qatar", code: "+974", iso: "QA" },
  { country: "Republic of the Congo", code: "+242", iso: "CG" },
  { country: "Reunion", code: "+262", iso: "RE" },
  { country: "Romania", code: "+40", iso: "RO" },
  { country: "Russia", code: "+7", iso: "RU" },
  { country: "Rwanda", code: "+250", iso: "RW" },
  { country: "Saint Barthelemy", code: "+590", iso: "BL" },
  { country: "Saint Helena", code: "+290", iso: "SH" },
  { country: "Saint Kitts and Nevis", code: "+1 (869)", iso: "KN" },
  { country: "Saint Lucia", code: "+1 (758)", iso: "LC" },
  { country: "Saint Martin", code: "+590", iso: "MF" },
  { country: "Saint Pierre and Miquelon", code: "+508", iso: "PM" },
  { country: "Saint Vincent and the Grenadines", code: "+1 (784)", iso: "VC" },
  { country: "Samoa", code: "+685", iso: "WS" },
  { country: "San Marino", code: "+378", iso: "SM" },
  { country: "Sao Tome and Principe", code: "+239", iso: "ST" },
  { country: "Saudi Arabia", code: "+966", iso: "SA" },
  { country: "Senegal", code: "+221", iso: "SN" },
  { country: "Serbia", code: "+381", iso: "RS" },
  { country: "Seychelles", code: "+248", iso: "SC" },
  { country: "Sierra Leone", code: "+232", iso: "SL" },
  { country: "Singapore", code: "+65", iso: "SG" },
  { country: "Sint Maarten", code: "+1 (721)", iso: "SX" },
  { country: "Slovakia", code: "+421", iso: "SK" },
  { country: "Slovenia", code: "+386", iso: "SI" },
  { country: "Solomon Islands", code: "+677", iso: "SB" },
  { country: "Somalia", code: "+252", iso: "SO" },
  { country: "South Africa", code: "+27", iso: "ZA" },
  { country: "South Korea", code: "+82", iso: "KR" },
  { country: "South Sudan", code: "+211", iso: "SS" },
  { country: "Spain", code: "+34", iso: "ES" },
  { country: "Sri Lanka", code: "+94", iso: "LK" },
  { country: "Sudan", code: "+249", iso: "SD" },
  { country: "Suriname", code: "+597", iso: "SR" },
  { country: "Svalbard and Jan Mayen", code: "+47", iso: "SJ" },
  { country: "Swaziland", code: "+268", iso: "SZ" },
  { country: "Sweden", code: "+46", iso: "SE" },
  { country: "Switzerland", code: "+41", iso: "CH" },
  { country: "Syria", code: "+963", iso: "SY" },
  { country: "Taiwan", code: "+886", iso: "TW" },
  { country: "Tajikistan", code: "+992", iso: "TJ" },
  { country: "Tanzania", code: "+255", iso: "TZ" },
  { country: "Thailand", code: "+66", iso: "TH" },
  { country: "Togo", code: "+228", iso: "TG" },
  { country: "Tokelau", code: "+690", iso: "TK" },
  { country: "Tonga", code: "+676", iso: "TO" },
  { country: "Trinidad and Tobago", code: "+1 (868)", iso: "TT" },
  { country: "Tunisia", code: "+216", iso: "TN" },
  { country: "Turkey", code: "+90", iso: "TR" },
  { country: "Turkmenistan", code: "+993", iso: "TM" },
  { country: "Turks and Caicos Islands", code: "+1 (649)", iso: "TC" },
  { country: "Tuvalu", code: "+688", iso: "TV" },
  { country: "U.S. Virgin Islands", code: "+1 (340)", iso: "VI" },
  { country: "Uganda", code: "+256", iso: "UG" },
  { country: "Ukraine", code: "+380", iso: "UA" },
  { country: "United Arab Emirates", code: "+971", iso: "AE" },
  { country: "Uruguay", code: "+598", iso: "UY" },
  { country: "Uzbekistan", code: "+998", iso: "UZ" },
  { country: "Vanuatu", code: "+678", iso: "VU" },
  { country: "Vatican", code: "+379", iso: "VA" },
  { country: "Venezuela", code: "+58", iso: "VE" },
  { country: "Vietnam", code: "+84", iso: "VN" },
  { country: "Wallis and Futuna", code: "+681", iso: "WF" },
  { country: "Western Sahara", code: "+212", iso: "EH" },
  { country: "Yemen", code: "+967", iso: "YE" },
  { country: "Zambia", code: "+260", iso: "ZM" },
  { country: "Zimbabwe", code: "+263", iso: "ZW" }
], vt = ({ children: e, loginComponent: r }) => {
  const { user: n } = O();
  return /* @__PURE__ */ t(j, { children: n === null ? r : e });
}, Ct = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `w-5 h-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" }) }), Nt = ({ className: e = "", height: r = 24, width: n = 24, colour: o = null }) => {
  const a = o ?? "#081F4C";
  return /* @__PURE__ */ s("svg", { className: e, width: n, height: r, viewBox: `0 0 ${n} ${r}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    "+  ",
    /* @__PURE__ */ t("path", { d: "M22.1719 10H2.17188M2.17188 8.2L2.17188 15.8C2.17188 16.9201 2.17188 17.4802 2.38986 17.908C2.58161 18.2843 2.88757 18.5903 3.26389 18.782C3.69172 19 4.25177 19 5.37187 19L18.9719 19C20.092 19 20.652 19 21.0799 18.782C21.4562 18.5903 21.7621 18.2843 21.9539 17.908C22.1719 17.4802 22.1719 16.9201 22.1719 15.8V8.2C22.1719 7.0799 22.1719 6.51984 21.9539 6.09202C21.7621 5.7157 21.4562 5.40974 21.0799 5.21799C20.652 5 20.092 5 18.9719 5L5.37188 5C4.25177 5 3.69172 5 3.26389 5.21799C2.88757 5.40973 2.58161 5.71569 2.38986 6.09202C2.17188 6.51984 2.17188 7.07989 2.17188 8.2Z", stroke: a, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}, kt = ({ className: e = "", colour: r = null }) => /* @__PURE__ */ t("svg", { className: `w-5 h-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: r ?? "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 13l4 4L19 7" }) }), Ve = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", className: `w-5 h-5 ${e}`, fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" }) }), Ge = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `h-5 w-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }) }), Lt = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `mx-auto h-5 w-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M5 15l7-7 7 7" }) }), v = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `mx-auto h-5 w-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M19 9l-7 7-7-7" }) }), F = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `mx-auto h-3 w-3 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1", d: "M19 9l-7 7-7-7" }) }), Mt = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `h-16 w-16 ${e}`, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 85 85", stroke: "currentColor", fill: "currentColor", children: /* @__PURE__ */ t(
  "path",
  {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    d: "M58.936 59.024c.878 0 1.626-.308 2.24-.923a3.051 3.051 0 0 0 .924-2.241V28.35c0-.879-.308-1.626-.923-2.241a3.051 3.051 0 0 0-2.241-.923H25.845c-.88 0-1.626.308-2.241.923a3.051 3.051 0 0 0-.923 2.241v27.51c0 .879.307 1.626.923 2.241a3.051 3.051 0 0 0 2.24.923h33.092zM42.5 38.809h-.044c-.44 0-.806-.161-1.099-.483l-.087-.044-12.041-9.932h26.323l-11.778 9.844-.087.044-.044.088a1.562 1.562 0 0 1-1.143.483zm16.436 17.05H25.845V29.625L39.16 40.611c.908.908 2.022 1.362 3.34 1.362s2.432-.469 3.34-1.406l13.096-10.943V55.86z"
  }
) }), Ze = ({ className: e = "" }) => /* @__PURE__ */ s("svg", { className: `animate-spin h-5 w-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: [
  /* @__PURE__ */ t("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
  /* @__PURE__ */ t("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })
] }), St = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `h-16 w-16 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "-11.25 -11.25 45 45", stroke: "currentColor", children: /* @__PURE__ */ t(
  "path",
  {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
  }
) }), zt = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { className: `mx-auto h-5 w-5 ${e}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" }) }), Bt = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", className: `mx-auto h-5 w-5 ${e}`, viewBox: "0 0 20 20", fill: "currentColor", children: /* @__PURE__ */ t(
  "path",
  {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
    clipRule: "evenodd"
  }
) }), Tt = ({ className: e = "" }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", className: `h-6 w-6 absolute pointer-events-none transform -translate-y-1/2 top-2/4 left-2 h-7 w-7 ${e}`, fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ t("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" }) }), At = ({ colour: e = null }) => {
  const r = e ?? "#FFFFFF";
  return /* @__PURE__ */ s("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.625 12C4.625 11.5168 5.01675 11.125 5.5 11.125H19.5C19.9832 11.125 20.375 11.5168 20.375 12C20.375 12.4832 19.9832 12.875 19.5 12.875H5.5C5.01675 12.875 4.625 12.4832 4.625 12Z", fill: r }),
    /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20.1187 11.3813C20.4604 11.723 20.4604 12.277 20.1187 12.6187L14.1187 18.6187C13.777 18.9604 13.223 18.9604 12.8813 18.6187C12.5396 18.277 12.5396 17.723 12.8813 17.3813L18.8813 11.3813C19.223 11.0396 19.777 11.0396 20.1187 11.3813Z", fill: r }),
    /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.8813 5.38128C13.223 5.03957 13.777 5.03957 14.1187 5.38128L20.1187 11.3813C20.4604 11.723 20.4604 12.277 20.1187 12.6187C19.777 12.9604 19.223 12.9604 18.8813 12.6187L12.8813 6.61872C12.5396 6.27701 12.5396 5.72299 12.8813 5.38128Z", fill: r })
  ] });
}, He = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17%2014.4996V11.494C17%2011.3145%2017%2011.2248%2016.9727%2011.1456C16.9485%2011.0755%2016.9091%2011.0117%2016.8572%2010.9587C16.7986%2010.8989%2016.7183%2010.8587%2016.5578%2010.7785L12%208.49958M4%209.49958V16.3062C4%2016.6781%204%2016.8641%204.05802%2017.0269C4.10931%2017.1708%204.1929%2017.3011%204.30238%2017.4077C4.42622%2017.5283%204.59527%2017.6057%204.93335%2017.7607L11.3334%2020.694C11.5786%2020.8064%2011.7012%2020.8626%2011.8289%2020.8848C11.9421%2020.9045%2012.0579%2020.9045%2012.1711%2020.8848C12.2988%2020.8626%2012.4214%2020.8064%2012.6666%2020.694L19.0666%2017.7607C19.4047%2017.6057%2019.5738%2017.5283%2019.6976%2017.4077C19.8071%2017.3011%2019.8907%2017.1708%2019.942%2017.0269C20%2016.8641%2020%2016.6781%2020%2016.3062V9.49958M2%208.49958L11.6422%203.67846C11.7734%203.61287%2011.839%203.58008%2011.9078%203.56717C11.9687%203.55574%2012.0313%203.55574%2012.0922%203.56717C12.161%203.58008%2012.2266%203.61287%2012.3578%203.67846L22%208.49958L12.3578%2013.3207C12.2266%2013.3863%2012.161%2013.4191%2012.0922%2013.432C12.0313%2013.4434%2011.9687%2013.4434%2011.9078%2013.432C11.839%2013.4191%2011.7734%2013.3863%2011.6422%2013.3207L2%208.49958Z'%20stroke='%23E6B300'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", _e = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%205V2'%20stroke='%23E31B54'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M17%202H9C6.64298%202%205.46447%202%204.73223%202.73223C4%203.46447%204%204.64298%204%207V22'%20stroke='%23E31B54'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%2011.125C8%208.66719%208%207.43829%208.57782%206.5555C8.82796%206.17334%209.14939%205.84521%209.52376%205.58986C10.3885%205%2011.5924%205%2014%205C16.4076%205%2017.6115%205%2018.4762%205.58986C18.8506%205.84521%2019.172%206.17334%2019.4222%206.5555C20%207.43829%2020%208.66719%2020%2011.125V12.875C20%2015.3328%2020%2016.5617%2019.4222%2017.4445C19.172%2017.8267%2018.8506%2018.1548%2018.4762%2018.4101C17.6115%2019%2016.4076%2019%2014%2019C11.5924%2019%2010.3885%2019%209.52376%2018.4101C9.14939%2018.1548%208.82796%2017.8267%208.57782%2017.4445C8%2016.5617%208%2015.3328%208%2012.875V11.125Z'%20stroke='%23E31B54'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%2010.3722C14.8571%206.24278%2013.5714%2013.0046%2020%2010.3723'%20stroke='%23E31B54'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M11%2022C12.6569%2022%2014%2020.6569%2014%2019'%20stroke='%23E31B54'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", je = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%2019H17'%20stroke='%23F79009'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M19%2016C19.7767%2016.0234%2020.24%2016.1102%2020.5607%2016.4313C21%2016.8713%2021%2017.5794%2021%2018.9957C21%2020.4119%2021%2021.12%2020.5607%2021.56C20.1213%2022%2019.4142%2022%2018%2022H6C4.58579%2022%203.87868%2022%203.43934%2021.56C3%2021.12%203%2020.4119%203%2018.9957C3%2017.5794%203%2016.8713%203.43934%2016.4313C3.75999%2016.1102%204.22328%2016.0234%205%2016'%20stroke='%23F79009'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M14.3151%2019C15.0417%2018.3718%2015.5%2017.4526%2015.5%2016.4286C15.5%2014.535%2013.933%2013%2012%2013C10.067%2013%208.5%2014.535%208.5%2016.4286C8.5%2017.4526%208.95829%2018.3718%209.6849%2019'%20stroke='%23F79009'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M20%2010L17.6052%2010C17.311%2010%2017.0209%209.93373%2016.7578%209.80643L14.7159%208.81844C14.4528%208.69114%2014.1627%208.62487%2013.8685%208.62487L12.8259%208.62487C11.8175%208.62487%2011%207.83382%2011%206.858C11%206.81856%2011.027%206.7839%2011.0662%206.77306L13.6071%206.07055C14.0629%205.94453%2014.551%205.98842%2014.975%206.19357L17.1579%207.24974M11%207.5L6.40723%208.91108C5.59303%209.16476%204.71292%208.86396%204.2029%208.1577C3.83414%207.64706%203.98428%206.91581%204.52154%206.60583L12.0371%202.26947C12.5151%201.99367%2013.0791%201.92638%2013.6048%202.08239L20%203.98005'%20stroke='%23F79009'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", De = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='10'%20stroke='%2314AE93'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M14%205.73791C14%205.73791%2012.8849%206.23808%2012.1017%205.85651C11.1464%205.39118%2010.1991%203.44619%2012.0914%202'%20stroke='%2314AE93'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8.00897%209H8M16%209H15.991'%20stroke='%2314AE93'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8%2015C8.91212%2016.2144%2010.3643%2017%2012%2017C13.6357%2017%2015.0879%2016.2144%2016%2015'%20stroke='%2314AE93'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Ue = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.4624%204C15.9685%204%2018%206.01472%2018%208.5C18%2010.9853%2015.9685%2013%2013.4624%2013C11.2388%2013%209.38874%2011.4138%209%209.32009'%20stroke='%233B7C0F'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M1.62861%203.57128C1.11583%203.77639%200.86641%204.35836%201.07152%204.87115C1.27664%205.38393%201.85861%205.63335%202.37139%205.42823L1.62861%203.57128ZM11.5777%202.77828L12.028%201.88538L12.0212%201.88199L12.0145%201.8787L11.5777%202.77828ZM14%203.99976L14.0003%204.99976C14.4634%204.99963%2014.8658%204.68157%2014.9729%204.23103C15.08%203.7805%2014.8637%203.31537%2014.4503%203.10686L14%203.99976ZM8.28515%205.49966C7.73287%205.49966%207.28515%205.94737%207.28515%206.49966C7.28515%207.05194%207.73287%207.49966%208.28515%207.49966V5.49966ZM12.2693%208.68828L12.0948%207.70363L12.2693%208.68828ZM10.2234%209.05096L10.398%2010.0356L10.2234%209.05096ZM6.89876%2010.1397L7.25824%2011.0728L6.89876%2010.1397ZM2%209.99966C1.44772%209.99966%201%2010.4474%201%2010.9997C1%2011.5519%201.44772%2011.9997%202%2011.9997V9.99966ZM9.30601%209.23243L9.03836%208.26891L9.03836%208.26891L9.30601%209.23243ZM11.5909%206.5311L11.7646%205.54629L11.7646%205.54629L11.5909%206.5311ZM13.0414%207.81678L14.0172%207.59781V7.59781L13.0414%207.81678ZM11.1275%203.67118L13.5497%204.89266L14.4503%203.10686L12.028%201.88538L11.1275%203.67118ZM12.0145%201.8787C11.0643%201.41739%2010.3115%201.18773%209.64086%201.08162C8.98627%200.97806%208.43186%200.999656%208%200.999656V2.99966C8.51242%202.99966%208.86905%202.98439%209.32833%203.05705C9.77156%203.12718%2010.3355%203.28682%2011.141%203.67787L12.0145%201.8787ZM12.0948%207.70363L10.0489%208.06631L10.398%2010.0356L12.4439%209.67293L12.0948%207.70363ZM6.53927%209.2065C5.54198%209.5907%204.00956%209.99966%202%209.99966V11.9997C4.2859%2011.9997%206.06185%2011.5337%207.25824%2011.0728L6.53927%209.2065ZM10.0489%208.06631C9.58712%208.14817%209.28388%208.20071%209.03836%208.26891L9.57365%2010.1959C9.70302%2010.16%209.88641%2010.1263%2010.398%2010.0356L10.0489%208.06631ZM7.25824%2011.0728C7.99942%2010.7873%208.55117%2010.5747%208.9413%2010.4269C9.13652%2010.353%209.28719%2010.2968%209.39879%2010.2564C9.45457%2010.2363%209.49766%2010.2212%209.5299%2010.2102C9.56488%2010.1984%209.57665%2010.1951%209.57365%2010.1959L9.03836%208.26891C8.78913%208.33814%207.97237%208.65442%206.53927%209.2065L7.25824%2011.0728ZM10.7692%207.49966C11.2409%207.49966%2011.3469%207.50349%2011.4173%207.51591L11.7646%205.54629C11.4783%205.49582%2011.1554%205.49966%2010.7692%205.49966V7.49966ZM11.4173%207.51591C11.8123%207.58556%2012.021%207.83665%2012.0657%208.03575L14.0172%207.59781C13.7705%206.49866%2012.8342%205.73488%2011.7646%205.54629L11.4173%207.51591ZM12.4439%209.67293C12.8697%209.59744%2013.2876%209.38968%2013.5953%209.06212C13.9113%208.72581%2014.153%208.20316%2014.0172%207.59781L12.0657%208.03575C12.0475%207.9544%2012.0541%207.87154%2012.0768%207.8029C12.0978%207.73936%2012.1267%207.70448%2012.1377%207.69274C12.1487%207.68096%2012.1507%207.68264%2012.1385%207.68902C12.1269%207.69507%2012.1112%207.70071%2012.0948%207.70363L12.4439%209.67293ZM8.28515%207.49966H10.0355V5.49966H8.28515V7.49966ZM10.0355%207.49966H10.7692V5.49966H10.0355V7.49966ZM13.9997%202.99976C11.9559%203.00032%2010.1627%204.28281%209.1699%205.9989L10.9011%207.00042C11.6163%205.76417%2012.8163%205.00008%2014.0003%204.99976L13.9997%202.99976ZM2.37139%205.42823C3.69018%204.90072%204.78763%204.217%205.64792%203.75623C6.54863%203.27382%207.24148%202.99966%208%202.99966V0.999656C6.72729%200.999656%205.67014%201.47554%204.70365%201.99318C3.69675%202.53246%202.80982%203.09879%201.62861%203.57128L2.37139%205.42823Z'%20fill='%233B7C0F'/%3e%3cpath%20d='M22%2014H19.6052C19.311%2014%2019.0209%2014.0663%2018.7578%2014.1936L16.7159%2015.1816C16.4528%2015.3089%2016.1627%2015.3751%2015.8685%2015.3751H14.8259C13.8175%2015.3751%2013%2016.1662%2013%2017.142C13%2017.1814%2013.027%2017.2161%2013.0662%2017.2269L15.6071%2017.9295C16.0629%2018.0555%2016.551%2018.0116%2016.975%2017.8064L19.1579%2016.7503M13%2016.5L8.40723%2015.0889C7.59304%2014.8352%206.71292%2015.136%206.2029%2015.8423C5.83414%2016.3529%205.98428%2017.0842%206.52154%2017.3942L14.0371%2021.7305C14.5151%2022.0063%2015.0791%2022.0736%2015.6048%2021.9176L22%2020.0199'%20stroke='%233B7C0F'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", We = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.19405%2014.077C1.94563%2015.3081%201.84437%2017.6176%202.13655%2019.7508C2.40166%2021.6863%204.57937%2022.5985%206.21199%2021.5762C9.1986%2019.7061%2012.3179%2017.2421%2015.3067%2014.2946C18.3772%2011.2665%2020.0596%208.96137%2021.5435%206.36746C22.4433%204.79457%2022.0218%202.69728%2020.1997%202.23217C18.2048%201.72298%2015.6191%201.93189%2013.3375%204.07744M3.19405%2014.077C2.36031%2010.337%205.29027%205.93182%2012.1656%209.79424M3.19405%2014.077C3.81736%2014.0897%205.21758%2014.3717%206.5544%2015.3244M6.84592%208.1954C6.90898%206.2548%208.82259%203.0048%2013.3375%204.07744M13.3375%204.07744C14.304%204.30706%2015.3897%204.73476%2016.602%205.41579'%20stroke='%23015AD6'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Ke = "data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.5295%207.35186C11.9571%207.75995%2011.2566%208%2010.5%208C8.567%208%207%206.433%207%204.5C7%202.567%208.567%201%2010.5%201C11.753%201%2012.8522%201.65842%2013.4705%202.64814M5%2019.0872H7.61029C7.95063%2019.0872%208.28888%2019.1277%208.61881%2019.2086L11.3769%2019.8789C11.9753%2020.0247%2012.5988%2020.0388%2013.2035%2019.9214L16.253%2019.3281C17.0585%2019.1712%2017.7996%2018.7854%2018.3803%2018.2205L20.5379%2016.1217C21.154%2015.5234%2021.154%2014.5524%2020.5379%2013.9531C19.9832%2013.4134%2019.1047%2013.3527%2018.4771%2013.8103L15.9626%2015.6449C15.6025%2015.9081%2015.1643%2016.0498%2014.7137%2016.0498H12.2855L13.8311%2016.0498C14.7022%2016.0498%2015.4079%2015.3633%2015.4079%2014.5159V14.2091C15.4079%2013.5055%2014.9156%2012.892%2014.2141%2012.7219L11.8286%2012.1417C11.4404%2012.0476%2011.0428%2012%2010.6431%2012C9.67833%2012%207.93189%2012.7988%207.93189%2012.7988L5%2014.0249M19%205.5C19%207.433%2017.433%209%2015.5%209C13.567%209%2012%207.433%2012%205.5C12%203.567%2013.567%202%2015.5%202C17.433%202%2019%203.567%2019%205.5ZM1%2013.6L1%2019.4C1%2019.9601%201%2020.2401%201.10899%2020.454C1.20487%2020.6422%201.35785%2020.7951%201.54601%2020.891C1.75992%2021%202.03995%2021%202.6%2021H3.4C3.96005%2021%204.24008%2021%204.45399%2020.891C4.64215%2020.7951%204.79513%2020.6422%204.89101%2020.454C5%2020.2401%205%2019.9601%205%2019.4V13.6C5%2013.0399%205%2012.7599%204.89101%2012.546C4.79513%2012.3578%204.64215%2012.2049%204.45399%2012.109C4.24008%2012%203.96005%2012%203.4%2012L2.6%2012C2.03995%2012%201.75992%2012%201.54601%2012.109C1.35785%2012.2049%201.20487%2012.3578%201.10899%2012.546C1%2012.7599%201%2013.0399%201%2013.6Z'%20stroke='%234A1FB8'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Oe = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2021V13.6C9%2013.0399%209%2012.7599%209.109%2012.546C9.20487%2012.3578%209.35785%2012.2049%209.54601%2012.109C9.75993%2012%2010.04%2012%2010.6%2012H13.4C13.9601%2012%2014.2401%2012%2014.454%2012.109C14.6422%2012.2049%2014.7951%2012.3578%2014.891%2012.546C15%2012.7599%2015%2013.0399%2015%2013.6V21M2%209.5L11.04%202.72C11.3843%202.46181%2011.5564%202.33271%2011.7454%202.28294C11.9123%202.23902%2012.0877%202.23902%2012.2546%202.28295C12.4436%202.33271%2012.6157%202.46181%2012.96%202.72L22%209.5M4%208V17.8C4%2018.9201%204%2019.4802%204.21799%2019.908C4.40974%2020.2843%204.7157%2020.5903%205.09202%2020.782C5.51985%2021%206.0799%2021%207.2%2021H16.8C17.9201%2021%2018.4802%2021%2018.908%2020.782C19.2843%2020.5903%2019.5903%2020.2843%2019.782%2019.908C20%2019.4802%2020%2018.9201%2020%2017.8V8L13.92%203.44C13.2315%202.92361%2012.8872%202.66542%2012.5091%202.56589C12.1754%202.47804%2011.8246%202.47804%2011.4909%202.56589C11.1128%202.66542%2010.7685%202.92361%2010.08%203.44L4%208Z'%20stroke='%238F691F'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", It = {
  "Emergency relief": _e,
  "Aid for Palestine": We,
  "Orphan care": De,
  "Where need is the Greatest": Ke,
  "Medical Support": Oe,
  Education: He,
  Zakat: Ue,
  Sadaqah: je
}, qe = {
  "sz-outline": `
    border-2 border-bluegray-600 hover:border-bluegray-900
    text-bluegray-600 hover:text-bluegray-900
    rounded-full
    px-8 py-3
    hover:shadow-lg"
  `,
  "ch-outline": `
    border border-1 border-ch-gray
    text-ch-blue text-ch-heading-16
    rounded-lg py-2 px-2 w-28 font-semibold
  `,
  "ch-save": `
    border-2 border-ch-green-100
    bg-ch-green-100
    text-white text-ch-heading-16 font-semibold
    rounded-lg
    py-2 px-2 w-28
  `,
  "sz-danger": `
    bg-sz-pink hover:bg-sz-pink-dark
    text-white
    rounded-full
    px-8 py-3
    hover:shadow-lg"
  `,
  "sz-primary": `
    bg-sz-gray-700 hover:bg-sz-gray-900
    text-sz-gray-50
    rounded-full
    px-8 py-3
    hover:shadow-lg"
  `,
  "sz-inverted": `
    bg-white border-2 border-white
    text-sz-gray-700 hover:text-sz-gray-900
    rounded-full
    px-8 py-3
    hover:shadow-lg"
  `,
  "ch-inverted": `
    bg-white 
    text-black 
    rounded-lg
    border-ch-grey
    "
  `,
  "ch-primary-green-md": `
    bg-ch-green-100
    text-white
    rounded-lg
    border-2 border-ch-green-100
    "
  `,
  "ch-primary": `
    bg-ch-orange
    text-white
    rounded-lg
    px-8 py-3"
  `,
  "ch-primary-md": `
    bg-ch-orange
    text-white
    rounded-lg
    px-2.5 py-2.5"
  `,
  "gm-primary": `
    bg-gm-green
    text-gm-gray-50
    text-2xl
    font-bold
    border-none
    px-7
    py-3
    rounded
    hover:shadow-lg
    disabled:opacity-30
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:duration-75
    active:shadow-inner
    active:bg-gm-yellow
    active:text-gm-green-900
  `,
  "gm-primary-newgreen": `
    bg-gm-newgreen
    text-white
    font-bold
    border-none
    py-2
    rounded-full
    hover:shadow-lg
    disabled:opacity-30
    focus:outline-none
    focus:ring-1
    focus:ring-gm-newgreen-200
    active:duration-75
    active:shadow-inner
    active:bg-gm-newgreen-200
  `,
  "gm-primary-md": `
    bg-gm-green
    text-gm-gray-50
    font-bold
    border-none
    px-3
    py-2
    rounded
    hover:shadow-lg
    disabled:opacity-30
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:duration-75
    active:shadow-inner
    active:bg-gm-yellow
    active:text-gm-green-900
  `,
  "gm-share": `
    bg-gm-yellow
    text-gm-green-900
    text-xl
    sm:text-2xl
    font-bold
    border-none
    px-7
    px-6
    md:px-5
    md:py-3
    py-1
    rounded
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    hover:shadow-lg
    active:duration-75
    active:shadow-inner
    active:bg-gm-green
    active:text-white
  `,
  "gm-secondary": `
    bg-transparent
    text-gm-green
    text-2xl
    font-bold
    border
    border-gm-green
    px-7
    py-3
    rounded
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:text-gm-green-900
    active:border-gm-green-900
  `,
  "gm-custom-secondary-md": `
    px-3 
    py-1
    bg-transparent
    rounded-md 
    shadow-md
    border
    border-gm-green
    text-gm-green
    font-bold 
    text-base
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:text-gm-green-900
    active:border-gm-green-900
  `,
  "gm-secondary-md": `
    px-3 
    rounded-md 
    shadow-md
    bg-transparent
    border
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:text-gm-green-900
    active:border-gm-green-900
  `,
  "gm-tertiary": `
    bg-transparent
    text-gm-green
    text-2xl
    underline
    font-bold
    border-none
    px-7
    py-3
    rounded
    focus:outline-none
    focus:ring-1
    focus:ring-gm-green-900
    active:text-gm-green-900
  `,
  "gm-inverted": `
    bg-white
    border-2 border-gm-green-500 hover:border-gm-green-700
    text-gm-green-700 hover:text-gm-green-900
    rounded-full
    px-8 py-3
    hover:shadow-lg
  `,
  "gm-widget": `
    bg-gm-yellow hover:bg-gm-yellow-dark
    text-gm-green-900 font-bold
    px-8 py-3
    text-gm-green-900
    rounded
    `,
  "gm-charity-outline": `
    bg-transparent
    border-2 border-gm-white
    rounded py-3
    text-white
    font-bold"
  `,
  "gm-charity-fundraiser-outline": `
    bg-transparent
    border-2 border-gm-yellow
    rounded
    px-8 py-3
    text-black
    font-bold"
  `,
  "gm-charity-sz-primary": `
    bg-white
    border-2
    rounded py-3
    font-bold
    border-white
    text-black"
  `,
  "mtn-primary": `
    bg-mtn-blue hover:bg-mtn-blue-700 disabled:bg-white
    border-2 border-mtn-blue disabled:border-mtn-gray-300
    text-mtn-white hover:text-mtn-blue disabled:text-mtn-blue-200
    font-medium
    min-w-40
    rounded-full
    px-8 py-2
    shadow-xl shadow-inner 
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-primary-beta": `
  bg-transparent hover:bg-mtn-white disabled:bg-mtn-gray-300
  border-2 border-mtn-white disabled:border-mtn-gray-300
  text-mtn-white hover:text-mtn-blue-800 disabled:text-mtn-blue-200
  font-bold
  min-w-40
  rounded-md
  px-8 py-2
  shadow-xl shadow-inner 
  outline-none focus:outline-none focus:ring-2
  cursor-pointer
`,
  "mtn-donate": `
    bg-mtn-gray-800 hover:bg-mtn-blue-400 disabled:bg-white
    text-mtn-blue-400 hover:text-mtn-gray-800 disabled:text-mtn-gray-400
    font-medium
    min-w-52
    rounded-full
    px-8 py-2
    hover:shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-black-text": `
    bg-mtn-white hover:bg-mtn-blue-900 disabled:bg-white
    text-mtn-blue-900 hover:text-mtn-white disabled:text-mtn-gray-400
    font-semibold
    min-w-52
    rounded-full
    px-8 py-2
    shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-donate-inverted": `
    bg-mtn-blue-800 hover:bg-mtn-blue-400 disabled:bg-white
    text-mtn-gray-800 hover:text-mtn-gray-800 disabled:text-mtn-gray-400
    font-medium
    min-w-52
    rounded-full
    px-8 py-2
    hover:shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-donate-now": `
    bg-mtn-gray-800 hover:bg-mtn-blue-400 
    border-mtn-gray-800 hover:border-mtn-gray-900
    text-mtn-blue-400 hover:text-mtn-gray-800 disabled:text-mtn-gray-400
    font-medium text-lg
    min-w-52
    rounded-full
    p-3
    sm:px-10 sm:py-2
    md:px-6 md:py-2
    hover:shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-payment-option": `
    bg-mtn-blue-dawn
    text-mtn-white-100
    rounded-lg
    p-3.5
    sm:px-10 sm:py-2
    md:px-6 md:py-2
    text-base
    min-w-52
    hover:shadow-lg
    focus:ring-2
    font-bold
  `,
  "mtn-share-button": `
    bg-mtn-gray-800 hover:bg-mtn-blue-400 
    border-mtn-gray-800 hover:border-mtn-gray-900
    text-mtn-blue-400 hover:text-mtn-gray-800 disabled:text-mtn-gray-400
    font-medium text-lg
    min-w-52
    rounded-sm
    p-3
    sm:px-10 sm:py-2
    md:px-6 md:py-2
    hover:shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-above-image": `
    bg-mtn-gray-200 hover:bg-mtn-blue-400 disabled:bg-white
    text-mtn-blue-600 hover:text-mtn-gray-800 disabled:text-mtn-gray-400
    font-medium
    text-xs text-center
    min-w-52
    rounded-full
    px-5 py-2
    hover:shadow-lg
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-redirection": `
    bg-fg-blue-500
    text-mtn-white-100
    rounded-lg
    p-3.5
    sm:px-10 sm:py-2
    md:px-6 md:py-2
    text-base
    min-w-52
    hover:shadow-lg
    focus:ring-2
    font-bold
  `,
  "mtn-tertiary": `
    underline
    font-medium
    text-xs
    text-mtn-blue-300 hover:text-mtn-gray-700
  `,
  "mtn-inverted": `
    bg-white hover:bg-mtn-blue
    border-2 border-mtn-gray-300 hover:border-mtn-blue-700
    font-medium text-mtn-blue-800 hover:text-white
    min-w-40
    rounded-full
    px-8 py-3
    hover:shadow-lg"
    outline-none focus:outline-none focus:ring-2
  `,
  "mtn-primary-beta-inverted": `
  bg-mtn-white disabled:bg-mtn-gray-300
  border-2 border-mtn-white disabled:border-mtn-gray-300
  text-mtn-blue-800 disabled:text-mtn-blue-200
  font-bold
  min-w-40
  rounded-md
  px-8 py-2
  shadow-xl shadow-inner 
  outline-none focus:outline-none focus:ring-2
  cursor-pointer
`,
  "mtn-outline": `
    bg-white
    border-2 border-mtn-blue-700 hover:border-mtn-blue-800
    text-mtn-blue-700  hover:text-mtn-blue-800
    rounded-full
    px-8 py-3
    hover:shadow-lg"
  `,
  "mtd-primary": `
    bg-mtd-primary hover:bg-mtd-primary-1 disabled:bg-mtd-gray-2
    text-white  disabled:text-mtd-gray-4
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-primary-outline": `
    bg-transparent hover:bg-mtd-primary disabled:bg-mtd-gray-2
    text-mtd-primary-1  disabled:text-mtd-gray-4
    border border-mtd-primary
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-secondary": `
    bg-mtd-secondary hover:bg-mtd-secondary-3 disabled:bg-mtd-gray-2
    text-white  disabled:text-mtd-gray-4
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-secondary-2": `
    bg-mtd-secondary-2 md:hover:bg-mtd-secondary-3 disabled:opacity-20
    text-mtd-secondary-4 disabled:opacity-20
    text-2xl
    rounded-lg
    h-9
    w-9
  `,
  "mtd-secondary-outline": `
    bg-transparent hover:bg-mtd-secondary disabled:bg-mtd-gray-2
    text-mtd-secondary-3  disabled:text-mtd-gray-4
    border border-mtd-secondary-3
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-greylight": `
    bg-mtd-gray-1 hover:bg-mtd-gray-3 disabled:bg-mtd-gray-2
    text-mtd-gray-6 disabled:text-mtd-gray-4
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-greylight-outline": `
    bg-transparent hover:bg-mtd-gray-1 disabled:bg-mtd-gray-2
    text-mtd-gray-3  disabled:text-mtd-gray-4
    border border-mtd-gray-1
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-white-outline": `
    bg-transparent disabled:bg-mtd-gray-2
    text-white  disabled:text-mtd-gray-4
    border border-white
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-blue": `
    bg-mtd-blue-1 hover:bg-mtd-blue-2 disabled:bg-mtd-gray-2
    text-white disabled:text-mtd-gray-4
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-blue-outline": `
    bg-transparent hover:bg-mtd-blue-1 disabled:bg-mtd-gray-2
    text-mtd-blue-2  disabled:text-mtd-gray-4
    border border-mtd-blue-1
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-grey": `
    bg-mtd-gray-3 hover:bg-mtd-gray-2 disabled:bg-mtd-gray-2
    text-mtd-gray-6 disabled:text-mtd-gray-4
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-grey-outline": `
    bg-transparent hover:bg-mtd-gray-3 disabled:bg-mtd-gray-2
    text-mtd-gray-3 disabled:text-mtd-gray-4
    border border-mtd-gray-3
    text-mtd-h2
    rounded-full
    px-8
    h-12
  `,
  "mtd-primary-old": `
    bg-mtd-yellow-100 disabled:bg-fg-gray-810
    text-white disabled:text-fg-gray-830
    font-medium
    min-w-40
    rounded-3xl
    px-8
    h-12
    hover:shadow-lg"
    outline-none focus:outline-none focus:ring-2
  `,
  "mtd-tertiary": `
    underline
    font-medium
    text-mtd-blue hover:text-mtd-blue-800
  `,
  "mtd-inverted": `
    bg-white hover:bg-mtd-blue
    border-2 border-mtd-gray-300 hover:border-mtd-blue
    font-medium text-mtd-blue-800 hover:text-white
    min-w-40
    rounded-full
    px-8 py-3
    hover:shadow-lg"
    outline-none focus:outline-none focus:ring-2
  `,
  "mtd-outline": `
    bg-white
    border-2 border-mtd-blue hover:border-mtd-blue-800
    text-mtd-blue hover:text-mtd-blue-800
    rounded-full
    px-8
    h-12
    hover:shadow-lg"
  `,
  "fg-primary": `
    bg-fg-orange hover:bg-fg-orange-100 disabled:bg-fg-gray-810
    text-white  disabled:text-fg-gray-830
    text-fg-h2 text-white
    rounded-xl
    h-12
  `,
  "fg-secondary": `
    bg-fg-blue-100 hover:bg-fg-blue-300
    text-fg-h2 text-white
    rounded-xl
    h-12
  `,
  "fg-secondary-outline": `
    bg-white
    border-2 border-fg-blue-100 hover:border-fg-blue-300
    text-fg-blue-100 hover:text-fg-blue-300
    rounded-xl
    h-12
  `,
  "fg-greylight": `
    bg-fg-gray-800 hover:bg-fg-gray-820
    text-fg-h2 text-fg-gray-850
    rounded-xl
    h-12
  `,
  "fg-grey": `
    bg-fg-gray-820 hover:bg-fg-gray-810
    text-fg-h2 text-fg-gray-850
    rounded-xl
    h-12
  `,
  "fg-indigo": `
    bg-fg-blue-400 hover:bg-fg-blue-600
    text-fg-h2 text-white
    rounded-xl
    h-12
  `,
  "fg-primary-old": `
    bg-mtn-blue hover:bg-mtn-blue-700 disabled:bg-white
    border-2 border-mtn-blue disabled:border-mtn-gray-300
    text-fg-cta-text text-white hover:text-mtn-blue disabled:text-mtn-blue-200
    font-medium
    min-w-40
    rounded-lg
    h-12
    shadow-xl shadow-inner 
    outline-none focus:outline-none focus:ring-2
  `,
  "fg-inverted": `
    bg-white hover:bg-fg-blue-500
    border-2 border-mtn-gray-300 hover:border-fg-blue-500
    font-medium text-fg-blue-500 hover:text-white
    min-w-40
    rounded-full
    px-8 py-3
    hover:shadow-lg"
    outline-none focus:outline-none focus:ring-2
  `
}, W = ({ variant: e, className: r, loading: n = !1, children: o, ...a }) => /* @__PURE__ */ s(
  "button",
  {
    className: `
    ${n ? "inline-flex justify-center" : ""}
    items-center
    ${qe[e]}
    ${r ?? ""}
    disabled:cursor-not-allowed
    hover:transition-colors
    duration-300
    `,
    ...a,
    children: [
      n && /* @__PURE__ */ t(Ze, { "data-test-id": x.buttonLoadingSpinner, className: "mr-3 -ml-3" }),
      " ",
      o
    ]
  }
), Ye = (e) => /* @__PURE__ */ t("div", { className: "flex items-center mt-4", children: e.isCompleted ? /* @__PURE__ */ s(j, { children: [
  /* @__PURE__ */ t("span", { role: "img", "aria-label": "green check mark", children: /* @__PURE__ */ t(Ve, { className: "mr-2 text-sz-green" }) }),
  /* @__PURE__ */ t("p", { children: "Completed" })
] }) : /* @__PURE__ */ s(j, { children: [
  /* @__PURE__ */ t("span", { role: "img", "aria-label": "incomplete mark", children: /* @__PURE__ */ t(Ge, { className: "mr-2 text-sz-pink" }) }),
  /* @__PURE__ */ t("p", { children: "Incomplete" })
] }) }), L = {
  sz: {
    select: `
      bg-white
      border border-sz-gray-700 hover:border-sz-gray-900
      appearance-none
      focus:outline-none focus:ring-2
      text-sz-gray-700
      pl-6 pr-20 py-3
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
     text-sz-gray-700 hover:text-sz-gray
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  "sz-inline": {
    select: `
      bg-white
      border border-sz-gray-700 hover:border-sz-gray-900
      appearance-none
      focus:outline-none focus:ring-2
      text-sz-gray-700
      pl-2 pr-20 py-3
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      inline text-sz-gray-700 hover:text-sz-gray
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  mtn: {
    select: `
      bg-white
      border border-mtn-blue-200 hover:border-mtn-blue
      appearance-none
      focus:outline-none focus:ring-2
      text-mtn-blue-800
      px-8 py-3
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-mtn-blue-800 hover:text-mtn-blue
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  "mtn-inline": {
    select: `
      inline
      bg-transparent
      appearance-none
      text-mtn-blue-800 hover:text-mtn-blue
      border-b border-mtn-blue-200 hover:border-mtn-blue
      pl-3 pr-6
      focus:outline-none focus:ring-2
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-mtn-blue-800 hover:text-mtn-blue
    `,
    chevron: /* @__PURE__ */ t(F, { className: "absolute pointer-events-none right-1 top-2/4 transform -translate-y-1/2" })
  },
  mtd: {
    select: `
      bg-white
      rounded-lg
      border 
      border-gray-4 focus:border-blue-1 hover:border-gray-5
      text-mtd-gray-4 focus:mtd-secondary-5
      text-mtd-input font-medium
      appearance-none
      px-8 py-3
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-mtd-gray-4 focus:mtd-secondary
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  mtdOld: {
    select: `
      bg-mtd-white
      rounded
      border border-mtd-blue-200 hover:border-mtd-blue
      appearance-none
      focus:outline-none focus:ring-2
      text-mtd-blue-900
      px-8 py-3
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-mtd-blue-900 hover:text-mtd-blue
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  gm: {
    select: `
      py-4
      px-8
      rounded
      bg-gm-gray-50
      appearance-none
      focus:outline-none focus:ring-2
      text-gm-green-900
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-gm-green-900 hover:text-gm-green
    `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-1 top-2/4 transform -translate-y-1/2" })
  },
  "gm-inline": {
    select: `
      inline
      bg-white
      rounded
      appearance-none
      text-gm-green-900
      border border-gm-green
      pl-4 pr-20
      py-2
      focus:outline-none focus:ring-2
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-gm-green-900 hover:text-gm-green
    `,
    chevron: /* @__PURE__ */ t(F, { className: "absolute pointer-events-none right-1 top-2/4 transform -translate-y-1/2" })
  },
  fg: {
    select: `
    border border-fg-gray-830 focus:border-fg-blue-400 hover:border-fg-gray-840
    text-fg-blue-830 empty:text-fg-gray-830 focus:text-fg-blue-650
    text-fg-input
    bg-white
    appearance-none
    outline-none
    rounded-lg
    px-8 py-3
    disabled:cursor-not-allowed
    transition-colors
    duration-300
  `,
    container: `
    text-fg-blue-830
  `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  "fg-inline": {
    select: `
      inline
      bg-transparent
      appearance-none
      text-fg-blue-830 empty:text-fg-gray-830 focus:text-fg-blue-650
      border-b border-fg-gray-830 focus:border-fg-blue-400 hover:border-fg-gray-840
      pl-3 pr-6
      transition-colors
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-fg-blue-830
    `,
    chevron: /* @__PURE__ */ t(F, { className: "absolute pointer-events-none right-1 top-2/4 transform -translate-y-1/2" })
  },
  charity: {
    select: `
    bg-white
    border border-ch-gray hover:border-ch-blue
    appearance-none rounded-xl
    focus:outline-none focus:ring-2
    text-ch-blue
    pl-3 pr-8 py-3
    transition-color
    duration-300
    disabled:cursor-not-allowed
  `,
    container: `
    text-ch-blue hover:text-ch-blue
  `,
    chevron: /* @__PURE__ */ t(v, { className: "absolute pointer-events-none right-2 top-2/4 transform -translate-y-1/2" })
  },
  "charity-inline": {
    select: `
      inline
      bg-transparent
      appearance-none
      text-ch-blue hover:text-ch-blue rounded-xl
      border-b border-ch-blue hover:border-ch-blue
      pl-3 pr-6
      focus:outline-none focus:ring-2
      transition-color
      duration-300
      disabled:cursor-not-allowed
    `,
    container: `
      text-ch-blue hover:text-ch-blue
    `,
    chevron: /* @__PURE__ */ t(F, { className: "absolute pointer-events-none right-1 top-2/4 transform -translate-y-1/2" })
  }
}, Et = R.forwardRef(({ variant: e, className: r, children: n, decoration: o, ...a }, c) => /* @__PURE__ */ s("div", { className: `${L[e].container} relative`, children: [
  L[e].chevron,
  o,
  /* @__PURE__ */ t(
    "select",
    {
      className: `
      ${L[e].select}
      ${r ?? ""}
    `,
      ref: c,
      ...a,
      children: n
    }
  )
] })), ie = ({ variant: e, className: r, children: n, decoration: o, ...a }) => /* @__PURE__ */ s("div", { className: `${L[e].container} relative`, children: [
  L[e].chevron,
  o,
  /* @__PURE__ */ t(
    "select",
    {
      className: `
      ${L[e].select}
      ${r ?? ""}
    `,
      ...a,
      children: n
    }
  )
] });
var se = /* @__PURE__ */ ((e) => (e.mtn = "mtn", e.mtd = "mtd", e.gm = "gm", e.fg = "fg", e))(se || {});
const w = {
  au: "Australia",
  ca: "Canada",
  ch: "Switzerland",
  es: "Spain",
  id: "Indonesia",
  ie: "Ireland",
  it: "Italy",
  my: "Malaysia",
  no: "Norway",
  za: "South Africa",
  sg: "Singapore",
  gb: "United Kingdom",
  us: "United States of America"
}, $t = ({ countries: e, value: r, onCountryChange: n, variant: o, FGFlag: a, className: c = "", ...i }) => {
  const d = (m) => {
    n(m.currentTarget.value);
  }, l = Array.from(e).sort((m, b) => w[m] > w[b] ? 1 : w[b] > w[m] ? -1 : 0);
  S(() => {
    l.length > 0 && !l.includes(r) && n(l[0]);
  }, [l, r, n]);
  const u = /* @__PURE__ */ t("img", { alt: "Flag", className: "absolute pointer-events-none top-2/4 left-2 transform -translate-y-1/2 h-7 w-7", src: `/assets/flags/${r}.svg` }), g = l.map((m, b) => /* @__PURE__ */ t("option", { value: m, children: w[m] }, b));
  return /* @__PURE__ */ t("div", { className: "relative", children: /* @__PURE__ */ t(
    ie,
    {
      "data-test-id": x.selectCountry,
      decoration: se.fg ? a : u,
      className: `pl-12 ${c}`,
      variant: o,
      value: r,
      onChange: d,
      ...i,
      children: g
    }
  ) });
}, Pt = ({ countries: e, value: r, onCountryChange: n, variant: o, className: a = "", ...c }) => {
  const i = (g) => {
    n(g.currentTarget.value);
  }, d = Array.from(e).sort((g, m) => w[g] > w[m] ? 1 : w[m] > w[g] ? -1 : 0);
  S(() => {
    d.length > 0 && !d.includes(r) && n(d[0]);
  }, [d, r, n]);
  const l = /* @__PURE__ */ t("img", { alt: "Flag", className: "absolute pointer-events-none top-2/4 left-2 transform -translate-y-1/2 h-7 w-7", src: `/assets/flags/${r}.svg` }), u = d.map((g, m) => /* @__PURE__ */ t("div", { className: "flex items-center", children: /* @__PURE__ */ t("img", { alt: "Flag", className: "h-7 w-7 mr-2", src: `/assets/flags/${g}.svg` }) }, m));
  return /* @__PURE__ */ t("div", { className: "relative", children: /* @__PURE__ */ t(
    ie,
    {
      "data-test-id": x.selectCountry,
      decoration: l,
      className: `pl-12 ${a}`,
      variant: o,
      value: r,
      onChange: i,
      ...c,
      children: u
    }
  ) });
};
var N = /* @__PURE__ */ ((e) => (e.mtn = "mtn", e.mtd = "mtd", e.mtdOld = "mtdOld", e.gm = "gm", e.sz = "sz", e.fg = "fg", e.charity = "charity", e.eg = "eg", e))(N || {});
const de = {
  mtn: `
    border
    text-mtn-blue-800
    font-medium
    appearance-none
    outline-none focus:ring-2
    px-6 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
    disabled:text-mtn-gray
  `,
  mtd: `
    border
    rounded-lg
    bg-white
    border-gray-4 focus:border-blue-1 hover:border-gray-5
    text-mtd-gray-4 focus:mtd-secondary-5
    text-mtd-input font-medium
    appearance-none
    disabled:cursor-not-allowed
    transition-colours
    duration-300
  `,
  mtdOld: `
    border
    rounded
    text-mtd-blue-900
    font-medium
    appearance-none
    outline-none focus:ring-2
    px-6 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
    disabled:text-mtd-gray
  `,
  sz: `
  border
  text-sz-gray-700
  appearance-none
  outline-none focus:ring-2
  px-6 py-3
  disabled:cursor-not-allowed
  transition-colours
  duration-300
  disabled:text-sz-gray
`,
  gm: `
  border 
  rounded 
  border-gm-green
  font-medium
  appearance-none
  outline-none focus:ring-2
  px-6 py-3
  disabled:cursor-not-allowed
  transition-colours
  duration-300
  disabled:text-mtn-gray
`,
  fg: `
    border border-fg-gray-830 focus:border-fg-blue-400 hover:border-fg-gray-840
    text-fg-blue-830 empty:text-fg-gray-830 focus:text-fg-blue-650
    text-fg-input
    bg-white
    placeholder-fg-placeholder
    appearance-none
    outline-none
    rounded-lg
    px-3 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
  `,
  charity: `
    border border-ch-gray
    text-ch-blue rounded-xl
    appearance-none
    outline-none focus:ring-1 focus:ring-ch-green-100 
    px-3 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
  `,
  eg: `
    border
    text-eg-green-100
    font-medium
    appearance-none
    border-eg-green-100
    outline-none focus:ring-2
    px-6 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
    disabled:text-mtn-gray
  `
}, le = {
  mtn: `
    bg-white border-mtn-blue-200 hover:border-mtn-blue-500 focus:border-mtn-blue-600
  `,
  mtd: `
    bg-mtd-white border-mtd-gray-4 hover:border-mtd-gray-5 focus:border-mtd-blue-1
  `,
  mtdOld: `
    bg-mtd-white border-mtd-blue-200 hover:border-mtd-blue focus:border-mtd-blue-600
  `,
  sz: `
    border-sz-gray-300 hover:border-sz-gray-700 focus:border-sz-gray-900
  `,
  gm: `
    bg-white border-gm-green-200 hover:border-gm-green focus:border-gm-green-600
  `,
  fg: `
    bg-white border-fg-blue-900 hover:border-fg-blue-900 focus:border-fg-blue-900
  `,
  charity: `
    bg-white border-ch-gray hover:border-ch-blue focus:border-ch-blue
  `,
  eg: `
    bg-white border-ch-green-100 hover:border-eg-green-100 hover:border-2 focus:border-eg-green-100 focus:ring-eg-green-100 focus:border-2
  `
}, ce = {
  mtn: `
    bg-mtn-red-light border-mtn-red hover:border-mtn-red-dark focus:border-mtn-red-dark focus:ring-mtn-red focus:ring-opacity-40
  `,
  mtd: `
    bg-mtd-red-light border-mtd-red hover:border-mtd-red-dark focus:border-mtd-red-dark focus:ring-mtd-red focus:ring-opacity-40
  `,
  mtdOld: `
    bg-mtd-red-light border-mtd-red hover:border-mtd-red-dark focus:border-mtd-red-dark focus:ring-mtd-red focus:ring-opacity-40
  `,
  sz: `
    border-sz-pink hover:border-sz-pink-dark focus:border-sz-pink-dark focus:ring-sz-pink focus:ring-opacity-40
  `,
  gm: `
    bg-gm-red-light border-gm-red hover:border-gm-red-dark focus:border-gm-red-dark focus:ring-gm-red focus:ring-opacity-40
  `,
  fg: `
  bg-mtn-red-light border-fg-red hover:border-fg-red focus:border-fg-red focus:ring-fg-red focus:ring-opacity-40
  `,
  charity: `
    bg-fg-red border-fg-red hover:border-fg-red focus:border-fg-red focus:ring-fg-red focus:ring-opacity-40
  `,
  eg: `
    bg-mtn-red-light border-mtn-red hover:border-mtn-red-dark focus:border-mtn-red-dark focus:ring-mtn-red focus:ring-opacity-40
  `
}, f = R.forwardRef(({ variant: e, className: r, invalid: n = !1, ...o }, a) => /* @__PURE__ */ t(
  "input",
  {
    className: `
    ${de[e]}
    ${r ?? ""}
    ${n ? ce[e] : le[e]}
  `,
    ref: a,
    ...o
  }
)), ue = ({ variant: e, className: r, invalid: n = !1, ...o }) => /* @__PURE__ */ t(
  "input",
  {
    className: `
    ${de[e]}
    ${r ?? ""}
    ${n ? ce[e] : le[e]}
    `,
    ...o
  }
);
function Ft(e) {
  return /* @__PURE__ */ t(
    f,
    {
      ...e,
      variant: e.variant,
      type: "email",
      autoComplete: "email",
      className: "rounded-lg h-12 p-2",
      ...e.register("email", {
        required: "Please provide an email address",
        onBlur: e.onBlur,
        validate: {
          isValid: (r) => e.requiredEmail && r !== e.requiredEmail ? "Please use the email you are currently logged in with or log out using the link above" : !0,
          pattern: D.validateEmail
        }
      }),
      invalid: e.errors !== void 0,
      id: "email",
      disabled: e.disabled,
      size: 1,
      placeholder: "Email address"
    }
  );
}
class Rt extends R.Component {
  constructor(r) {
    super(r), this.state = { hasError: !1 };
  }
  componentDidCatch(r) {
    console.error(r), this.setState({ hasError: !0 });
  }
  render() {
    return this.state.hasError ? this.props.component : this.props.children;
  }
}
const Vt = ({ checkbox: e, className: r = "", children: n, longCopy: o }) => {
  const [a, c] = M(!1);
  return /* @__PURE__ */ s("div", { className: `${r} flex flex-col cursor-pointer`, children: [
    /* @__PURE__ */ s("label", { children: [
      n !== void 0 && /* @__PURE__ */ t("div", { children: /* @__PURE__ */ s("span", { className: "font-bold text-mtn-blue-800", children: [
        " ",
        n
      ] }) }),
      /* @__PURE__ */ s("div", { className: "flex items-center my-3", children: [
        e,
        /* @__PURE__ */ t("span", { className: "ml-4 text-base md:text-lg ", children: "Yes, I'd like to include GiftAid" })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "text-xs", children: [
      "By selecting yes, I declare that I am UK taxpayer.",
      /* @__PURE__ */ s("span", { className: "font-bold cursor-pointer", onClick: () => c(!a), children: [
        " read ",
        a ? "less" : "more",
        " "
      ] }),
      a && (o ? /* @__PURE__ */ t("p", { className: "mt-2", children: o }) : /* @__PURE__ */ s("p", { className: "mt-2", children: [
        "I understand that if I pay less Income Tax and/or Capital Gains Tax in the current tax year than the amount of Gift Aid claimed on my donations I must pay the difference. I am happy for Mercy Mission to claim Gift Aid on this donation and on prior donations I have made in the past to Mercy Mission where applicable. Mercy Mission reserves the right to use third party service providers to collect gift aid on its behalf. Where necessary, your personal data may be shared with your chosen charity or our third-party providers in order to process your gift aid. For more information, please see our Privacy Policy.",
        /* @__PURE__ */ t("p", { className: "mt-2", children: "Where Mercy Mission deems it appropriate, Mercy Mission may use all or parts of this GiftAid to cover costs from 3rd party partners, including but not limited to fundraisers, donor advised fund fees and/or other third party providers who help facilitate or promote donations. This helps keep costs lower for charities, since the costs may be taken from the gift aid and thereby maintaining a free platform for your chosen charity and therefore furthers Mercy Mission’s charitable objects. If you do not agree with this, you should not select yes." })
      ] }))
    ] })
  ] });
}, me = ({ children: e, disabled: r = !1, className: n = "", ...o }) => /* @__PURE__ */ t("div", { className: `flex flex-col rounded-xl p-6 mt-8 sm:mt-0 ${r ? "cursor-not-allowed" : "shadow-lg cursor-pointer transform duration-300 hover:shadow-none hover:translate-y-1"} ${n}`, ...o, children: e }), E = {
  sz: {
    default: `
      text-sz-gray
    `,
    error: `
      text-sm
      text-sz-pink
      min-h-xs
      mt-2
      text-right
    `,
    link: `
      text-sz-gray-700 underline
    `
  },
  mtn: {
    default: `
      text-mtn-blue-800
    `,
    error: `
      text-xs
      text-mtn-red
      min-h-xs
      mt-2
      text-right
    `,
    link: `
      text-mtn-blue underline
    `
  }
}, Gt = ({
  fontVariant: e,
  buttonVariant: r,
  trackingSignInCode: n,
  trackingSignInEmail: o,
  trackingLogInCode: a,
  className: c,
  email: i,
  emailUnEditable: d,
  track: l,
  platform: u,
  ...g
}) => {
  const { showLoginConfirm: m, setShowLoginConfirm: b, startLogin: V, confirmLogin: G } = O(), { register: z, handleSubmit: Z, formState: p, watch: h } = re({
    defaultValues: {
      email: i ?? "",
      code: "",
      platform: u ?? ""
    }
  }), { mutate: B, isError: H, isLoading: T, error: A } = ne(async (y) => {
    if (!m) {
      await V(y.email), o == null || o(y.email), b(!0);
      return;
    }
    await G(y.email, y.code, y.platform), a == null || a(y.email);
  }, {
    onSuccess: (y, C) => {
      n == null || n(C.email), l == null || l();
    }
  }), pe = h("email");
  S(() => {
    b(!!i);
  }, [pe, b, i]);
  const q = (() => {
    var y, C;
    return !H || m ? ((C = (y = p == null ? void 0 : p.errors) == null ? void 0 : y.email) == null ? void 0 : C.message) ?? "" : A instanceof J ? "Sorry, we didn't recognise that email address" : "We were unable to accept that email address";
  })(), Y = (() => {
    var y, C;
    return m ? H ? A instanceof J ? "Sorry, we don't think that was the right code" : "Oops. We weren't able to log you in right now. Please try again" : ((C = (y = p == null ? void 0 : p.errors) == null ? void 0 : y.code) == null ? void 0 : C.message) ?? "" : "";
  })();
  return /* @__PURE__ */ s("form", { onSubmit: Z(
    (y) => B(y)
  ), className: c, ...g, children: [
    /* @__PURE__ */ s("div", { className: "mt-4 sm:flex", children: [
      /* @__PURE__ */ t("label", { className: `w-40 pr-4 mt-3 ${E[e].default}`, htmlFor: "email", children: "Email Address" }),
      /* @__PURE__ */ s("div", { className: "flex flex-col flex-1", children: [
        /* @__PURE__ */ t(
          f,
          {
            "data-test-id": x.loginFormEmailInput,
            variant: e,
            type: "email",
            autoComplete: "email",
            ...z("email", { required: "Please provide an email address" }),
            invalid: q !== "",
            disabled: d ?? !1,
            id: "email"
          }
        ),
        /* @__PURE__ */ t("p", { "data-test-id": x.loginFormEmailErrorMessage, className: E[e].error, children: q })
      ] })
    ] }),
    m && /* @__PURE__ */ s("div", { className: "mt-4 sm:flex", children: [
      /* @__PURE__ */ t("label", { className: `w-100 pr-4 mt-4 ${E[e].default}`, htmlFor: "code", children: "Please check your email for a login code" }),
      /* @__PURE__ */ s("div", { className: "flex flex-col flex-1", children: [
        /* @__PURE__ */ t(
          f,
          {
            "data-test-id": x.loginFormLoginCode,
            variant: e,
            type: "number",
            placeholder: "Login Code",
            autoComplete: "off",
            ...z("code", { required: "Please provide the login token we sent to your email address" }),
            invalid: Y !== "",
            id: "code"
          }
        ),
        /* @__PURE__ */ t(
          "p",
          {
            "data-test-id": x.loginFormErrorMessage,
            className: E[e].error,
            children: Y
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex justify-end mt-10", children: /* @__PURE__ */ t(
      W,
      {
        "data-test-id": x.loginFormSubmitButton,
        disabled: !p.isDirty || T,
        loading: T,
        variant: r,
        children: "SUBMIT"
      }
    ) }),
    g.showContactUs && /* @__PURE__ */ s("p", { className: "mt-20", children: [
      "If you can't log in, please ",
      /* @__PURE__ */ t(Be, { className: E[e].link, to: "/contact", children: "contact us" })
    ] })
  ] });
}, Je = () => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ t("path", { d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: "#757575" }) }), Zt = () => /* @__PURE__ */ t("svg", { width: "18", height: "17", viewBox: "0 0 18 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ t("path", { d: "M9.9375 12.332C9.9375 12.5175 9.88252 12.6987 9.77951 12.8529C9.67649 13.007 9.53007 13.1272 9.35877 13.1982C9.18746 13.2691 8.99896 13.2877 8.81711 13.2515C8.63525 13.2153 8.4682 13.1261 8.33709 12.9949C8.20598 12.8638 8.11669 12.6968 8.08052 12.5149C8.04434 12.3331 8.06291 12.1446 8.13387 11.9733C8.20482 11.802 8.32499 11.6555 8.47916 11.5525C8.63333 11.4495 8.81458 11.3945 9 11.3945C9.24864 11.3945 9.4871 11.4933 9.66292 11.6691C9.83873 11.8449 9.9375 12.0834 9.9375 12.332ZM9 3.89453C7.27657 3.89453 5.875 5.15625 5.875 6.70703V7.01953C5.875 7.18529 5.94085 7.34426 6.05806 7.46147C6.17527 7.57868 6.33424 7.64453 6.5 7.64453C6.66576 7.64453 6.82474 7.57868 6.94195 7.46147C7.05916 7.34426 7.125 7.18529 7.125 7.01953V6.70703C7.125 5.84766 7.96641 5.14453 9 5.14453C10.0336 5.14453 10.875 5.84766 10.875 6.70703C10.875 7.56641 10.0336 8.26953 9 8.26953C8.83424 8.26953 8.67527 8.33538 8.55806 8.45259C8.44085 8.5698 8.375 8.72877 8.375 8.89453V9.51953C8.375 9.68529 8.44085 9.84426 8.55806 9.96147C8.67527 10.0787 8.83424 10.1445 9 10.1445C9.16576 10.1445 9.32474 10.0787 9.44195 9.96147C9.55916 9.84426 9.625 9.68529 9.625 9.51953V9.46328C11.05 9.20156 12.125 8.06484 12.125 6.70703C12.125 5.15625 10.7234 3.89453 9 3.89453ZM17.125 8.26953C17.125 9.8765 16.6485 11.4474 15.7557 12.7835C14.8629 14.1197 13.594 15.1611 12.1093 15.7761C10.6247 16.391 8.99099 16.5519 7.4149 16.2384C5.8388 15.9249 4.39106 15.1511 3.25476 14.0148C2.11846 12.8785 1.34463 11.4307 1.03112 9.85464C0.717618 8.27854 0.87852 6.64488 1.49348 5.16023C2.10844 3.67558 3.14985 2.40663 4.486 1.51384C5.82214 0.621054 7.39303 0.144531 9 0.144531C11.1542 0.146806 13.2195 1.00356 14.7427 2.5268C16.266 4.05004 17.1227 6.11535 17.125 8.26953ZM15.875 8.26953C15.875 6.90978 15.4718 5.58057 14.7164 4.44999C13.9609 3.3194 12.8872 2.43821 11.631 1.91786C10.3747 1.39751 8.99238 1.26136 7.65876 1.52663C6.32514 1.79191 5.10013 2.44669 4.13864 3.40817C3.17716 4.36966 2.52238 5.59467 2.2571 6.92829C1.99183 8.2619 2.12798 9.64424 2.64833 10.9005C3.16868 12.1567 4.04987 13.2305 5.18046 13.9859C6.31105 14.7413 7.64026 15.1445 9 15.1445C10.8227 15.1425 12.5702 14.4175 13.8591 13.1286C15.1479 11.8397 15.8729 10.0923 15.875 8.26953Z", fill: "#061E4B" }) }), Ht = ({ overlay: e, isOpen: r, onClose: n, children: o, className: a, backgroundColor: c, closeButtonStyles: i, backdropColor: d }) => (S(() => {
  const l = (u) => {
    u.key === "Escape" && n();
  };
  return r && (window.addEventListener("keydown", l), document.body.style.overflow = e ? "hidden" : "auto"), () => {
    document.body.style.overflow = "auto", window.removeEventListener("keydown", l);
  };
}, [r, n, e]), r ? /* @__PURE__ */ t("div", { className: "fixed inset-0 z-50", children: /* @__PURE__ */ s("div", { className: "flex px-4 pt-4 max-h-screen text-center sm:p-0", children: [
  /* @__PURE__ */ t("div", { className: "fixed inset-0 transition-opacity", "aria-hidden": "true" }),
  /* @__PURE__ */ t("div", { className: `fixed inset-0 ${d ?? "bg-sz-gray-900 opacity-30"}` }),
  /* @__PURE__ */ t("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true", children: "​" }),
  /* @__PURE__ */ s(
    "div",
    {
      className: `p-4 text-left m-auto ${c ?? "bg-white"} rounded-2xl shadow-xl transition-all flex flex-col transform ${e ? "w-screen h-screen fixed left-0 top-0 rounded-none overflow-auto p-4" : "overflow-hidden max-w-xl p-8 pt-6"} ${a ?? ""}`,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline",
      children: [
        /* @__PURE__ */ t("button", { "data-test-id": x.closeModalButton, className: `${i ?? ""} flex justify-end mb-4`, onClick: n, children: Je() }),
        o
      ]
    }
  )
] }) }) : null), _t = ({
  skinny: e = !1,
  wide: r = !1,
  className: n = "",
  children: o,
  ...a
}) => /* @__PURE__ */ t("div", { className: ((i, d, l) => i ? `max-w-3xl mx-auto ${l ?? ""}` : d ? `sm:mx-20 ${l ?? ""}` : `${l ?? ""}`)(e, r, n), ...a, children: o }), jt = ({ tracking: e, eventPropsFunctions: r, trackable: n }) => {
  const { pathname: o } = ae(), { user: a } = O(), c = Te();
  return S(() => {
    var i;
    if ((i = window.HubSpotConversations) != null && i.widget && window.HubSpotConversations.widget.refresh(), n(o) || n(c)) {
      const d = r ? r.map((l) => l()).reduce(
        (l, u) => ({ ...l, ...u }),
        {}
      ) : {};
      c ? e.FGPageView(c, a == null ? void 0 : a.email, d) : e.pageView(o, a == null ? void 0 : a.email, d);
    }
  }, [o, a, e, r, n, c]), null;
}, $ = {
  [N.mtn]: {
    container: `
      border border-mtn-blue-200 hover:border-mtn-blue-500 focus:border-mtn-blue-600
      text-mtn-blue-800
      font-medium
      bg-mtn-gray-200
    `,
    option: `
      hover:bg-mtn-gray-200
    `,
    chevron: `
      hover:text-mtn-blue
    `,
    dropdown: `
      bg-white 
      border border-mtn-blue-200
    `
  },
  [N.sz]: {
    container: `
      border border-sz-gray-300 hover:border-sz-gray-700 focus:border-sz-gray-900
      bg-white
      text-sz-gray-700
    `,
    option: `
      hover:bg-sz-gray-50
    `,
    chevron: `
      hover:text-sz-gray-700
    `,
    dropdown: `
      bg-white 
      border border-sz-gray-300
    `
  },
  [N.fg]: {
    container: `
      border border-fg-gray-840 focus:border-fg-blue-400
      text-fg-blue-650 empty:text-fg-gray-830 focus:text-fg-blue-650
      font-medium
      bg-white
    `,
    option: `
      hover:bg-mtn-gray-200
    `,
    chevron: `
      hover:text-mtn-blue
    `,
    dropdown: `
      bg-white 
      border border-fg-gray-400
    `
  },
  [N.charity]: {
    container: `
      border border-mtn-blue-200 hover:border-mtn-blue-500 focus:border-mtn-blue-600
      text-mtn-blue-800
      font-medium
      bg-mtn-gray-200
    `,
    option: `
      hover:bg-mtn-gray-200
    `,
    chevron: `
      hover:text-mtn-blue
    `,
    dropdown: `
      bg-white 
      border border-mtn-blue-200
    `
  },
  [N.eg]: {
    container: `
      border border-eg-green-100 hover:border-eg-green-100 focus:border-eg-green-100
      text-mtn-blue-800
      font-medium
      bg-mtn-gray-200
    `,
    option: `
      hover:bg-mtn-gray-200
    `,
    chevron: `
      hover:text-mtn-blue
    `,
    dropdown: `
      bg-white 
      border border-mtn-blue-200
    `
  }
}, ge = ({ onChange: e, value: r, variant: n }) => {
  const [o, a] = M(!1), c = ve.map((d, l) => /* @__PURE__ */ s(
    "div",
    {
      className: `py-1 px-4 cursor-pointer ${$[n].option}`,
      onClick: (u) => {
        u.stopPropagation(), e(k[d.code]), a(!1);
      },
      children: [
        d.name,
        " ",
        k[d.code]
      ]
    },
    l
  )), i = Ce.map((d, l) => /* @__PURE__ */ s(
    "div",
    {
      className: `py-1 px-4 cursor-pointer ${$[n].option}`,
      onClick: (u) => {
        u.stopPropagation(), e(k[d.code]), a(!1);
      },
      children: [
        d.name,
        " ",
        k[d.code]
      ]
    },
    l
  ));
  return /* @__PURE__ */ s(
    "div",
    {
      className: `relative appearance-none outline-none focus:ring-2 transition-colours duration-300 ${$[n].container}`,
      onBlur: () => a(!1),
      tabIndex: 0,
      children: [
        /* @__PURE__ */ s("span", { className: "flex items-center py-3 px-2 cursor-pointer", onClick: () => a(!0), children: [
          /* @__PURE__ */ t("span", { className: "mr-2", children: r }),
          /* @__PURE__ */ t(F, { className: $[n].chevron })
        ] }),
        o && /* @__PURE__ */ s("div", { className: `absolute top-full left-0 h-80 w-72 sm:w-96 overflow-y-auto ${$[n].dropdown}`, children: [
          c,
          /* @__PURE__ */ t("div", { className: "px-4", children: "──────────" }),
          i
        ] })
      ]
    }
  );
}, Dt = ({ defaultCountry: e, className: r, variant: n, handleChange: o, invalid: a = !1, ...c }) => {
  const [i, d] = M(k[e ?? "gb"]), [l, u] = M("");
  return /* @__PURE__ */ s("div", { className: `flex ${r ?? ""}`, children: [
    /* @__PURE__ */ t(
      ge,
      {
        variant: n,
        onChange: (g) => {
          d(g), o(g + l.replace(/^0+/, ""));
        },
        value: i
      }
    ),
    /* @__PURE__ */ t(
      ue,
      {
        variant: n,
        className: "flex-1 ml-6",
        type: "tel",
        autoComplete: "tel-national",
        onChange: (g) => {
          u(g.target.value), o(i + g.target.value.replace(/^0+/, ""));
        },
        value: l,
        size: 1,
        invalid: a
      }
    ),
    /* @__PURE__ */ t("input", { type: "hidden", ...c })
  ] });
}, Ut = Se(({ defaultCountry: e, name: r, setValue: n, className: o, variant: a, invalid: c = !1, ...i }, d) => {
  const [l, u] = M(k[e ?? "gb"]), [g, m] = M("");
  return S(() => {
    n(r, l + g.replace(/^0+/, ""));
  }, [l, g, r, n]), /* @__PURE__ */ s("div", { className: `flex ${o ?? ""}`, children: [
    /* @__PURE__ */ t(
      ge,
      {
        variant: a,
        onChange: (b) => u(b),
        value: l
      }
    ),
    /* @__PURE__ */ t(
      ue,
      {
        variant: a,
        className: "flex-1 ml-6",
        type: "tel",
        autoComplete: "tel-national",
        onChange: (b) => m(b.target.value),
        value: g,
        size: 1,
        invalid: c
      }
    ),
    /* @__PURE__ */ t("input", { type: "hidden", ref: d, ...i })
  ] });
}), Xe = {
  completed: "bg-ch-orange",
  incomplete: "bg-white",
  current: "bg-ch-orange"
}, Qe = {
  completed: "text-ch-orange",
  incomplete: "text-white",
  current: "text-ch-orange"
}, Wt = ({ currentStep: e, totalSteps: r, showStepCount: n = !0, bgColours: o = Xe, textColours: a = Qe }) => /* @__PURE__ */ t("div", { className: "flex w-full justify-self-center gap-x-1", children: Array.from({ length: r }, (c, i) => /* @__PURE__ */ s("div", { className: "flex-1 text-center", children: [
  /* @__PURE__ */ t("div", { className: `w-full h-1.5 ${e >= i ? e === i ? o.current : o.completed : o.incomplete} rounded-lg transition` }),
  n && /* @__PURE__ */ s("p", { className: `text-${e >= i ? e === i ? a.current : a.completed : a.incomplete} text-ch-paragraph-xsmall transition`, children: [
    "Step ",
    i + 1
  ] })
] }, i)) }), et = {
  mtn: `
    h-4 w-4
    rounded-full
    border border-mtn-gray checked:border-mtn-blue
    checked:bg-mtn-blue bg-center
    mr-4
    focus:outline-none focus:ring-2
    transform transition-colors duration-300
  `
}, Kt = ({ variant: e, ...r }) => /* @__PURE__ */ t(
  "input",
  {
    style: { backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>')` },
    className: `appearance-none ${et[e]}`,
    type: "radio",
    ...r
  }
), Ot = ({ title: e, children: r, show: n, handleClose: o, handleSubmit: a, isLoading: c, actionButtonTitle: i = "Save Changes", actionButtonColor: d = "primary" }) => /* @__PURE__ */ t(j, { children: /* @__PURE__ */ s(I, { show: n, onHide: o, children: [
  /* @__PURE__ */ t(I.Header, { closeButton: !0, children: /* @__PURE__ */ t(I.Title, { children: e }) }),
  /* @__PURE__ */ t(I.Body, { children: r }),
  /* @__PURE__ */ s(I.Footer, { children: [
    /* @__PURE__ */ t(X, { variant: "secondary", onClick: o, children: "Close" }),
    /* @__PURE__ */ t(X, { disabled: c, variant: d, onClick: a, type: "submit", children: i })
  ] })
] }) }), qt = () => {
  const { pathname: e } = ae();
  return R.useEffect(() => {
    var r;
    (r = window == null ? void 0 : window.scrollTo) == null || r.call(window, 0, 0);
  }, [e]), null;
}, Yt = ({ title: e, index: r, currentIndex: n, onClick: o }) => /* @__PURE__ */ s("div", { className: `cursor-pointer ${r === n ? "text-gm-green-500 underline" : ""}`, onClick: o, children: [
  " ",
  e
] }), Jt = ({ index: e, currentIndex: r, children: n }) => /* @__PURE__ */ t("div", { className: `${e === r ? "block" : "hidden"}`, children: n }), Xt = ({ objects: e, properties: r }) => /* @__PURE__ */ s("table", { className: "border-separate border border-slate-500", children: [
  /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ t("tr", { children: r.map((n) => /* @__PURE__ */ t("th", { className: "text-left border border-slate-600", children: n.header })) }) }),
  /* @__PURE__ */ t("tbody", { children: e.map((n) => /* @__PURE__ */ t("tr", { children: r.map((o) => /* @__PURE__ */ t("td", { className: "border border-slate-700", children: o.render ? o.render(n[o.key]) : n[o.key] })) })) })
] }), Qt = () => /* @__PURE__ */ t("p", { className: "flex justify-center md:text-lg font-bold text-sm", children: "All donations are tax-deductible" }), he = {
  sz: `
  border
  text-sz-gray-700
  appearance-none
  outline-none focus:ring-2
  px-6 py-3
  disabled:cursor-not-allowed
  transition-colours
  duration-300
  disabled:text-sz-gray
  `,
  charity: `
    border border-ch-gray
    text-ch-blue rounded-xl
    appearance-none
    outline-none focus:ring-1 focus:ring-ch-green-100
    px-3 py-3
    disabled:cursor-not-allowed
    transition-colours
    duration-300
  `
}, be = {
  sz: `
    border-sz-gray-300 hover:border-sz-gray-700 focus:border-sz-gray-900
  `,
  charity: `
    bg-white border-ch-gray hover:border-ch-blue focus:border-ch-blue
  `
}, ye = {
  sz: `
    border-sz-pink hover:border-sz-pink-dark focus:border-sz-pink-dark focus:ring-sz-pink focus:ring-opacity-40
  `,
  charity: `
    bg-fg-red border-fg-red hover:border-fg-red focus:border-fg-red focus:ring-fg-red focus:ring-opacity-40
  `
}, ee = R.forwardRef(({ variant: e, className: r, invalid: n = !1, ...o }, a) => /* @__PURE__ */ t(
  "textarea",
  {
    className: `
    ${he[e]}
    ${r ?? ""}
    ${n ? ye[e] : be[e]}
  `,
    ref: a,
    ...o
  }
)), eo = ({ variant: e, className: r, invalid: n = !1, ...o }) => /* @__PURE__ */ t(
  "textarea",
  {
    className: `
    ${he[e]}
    ${r ?? ""}
    ${n ? ye[e] : be[e]}
    `,
    ...o
  }
), to = ({
  children: e,
  charityId: r,
  getStripe: n,
  stripeElementsOptions: o
}) => {
  const a = ze(async () => n(r), [n, r]);
  return /* @__PURE__ */ t(Ae, { options: o, stripe: a, children: e });
}, tt = { width: 300, height: 300 }, ot = { width: 250, height: 100 }, te = 3, oo = (e) => {
  var u, g, m, b, V, G, z, Z, p;
  const { charity: r, updateTaxReceiptsData: n } = e, o = re(
    {
      defaultValues: c(r == null ? void 0 : r.tax_receipts_data)
    }
  ), a = ne(async (h) => {
    const [B, H] = o.getValues(["logo_image", "signature_image"]), T = B[0], A = H[0];
    await Fe(r.id, T, A), h.logo_image_name = T.name, h.signature_image_name = A.name, await n(h);
  }, {
    onSuccess: () => {
      i();
    }
  });
  function c(h) {
    if (h)
      return {
        ...h,
        signature_image: Q(h.signature_image_name),
        logo_image: Q(h.logo_image_name)
      };
  }
  const i = async () => {
    const h = await Re(r.id, o.getValues());
    Ne("taxReceipt.pdf", h);
  };
  async function d(h, B) {
    return h ? P(h[0]) ? !0 : await D.validateImageSize(h, B) : !1;
  }
  function l(h) {
    return h.split(`
`).length > te ? `Address can't contain more than ${te} lines` : !0;
  }
  return /* @__PURE__ */ s("form", { onSubmit: o.handleSubmit(
    (h) => a.mutate(h)
  ), children: [
    /* @__PURE__ */ t("h1", { className: "font-mono text-lg font-bold text-sz-gray-700", children: "Tax Receipts" }),
    /* @__PURE__ */ t("p", { className: "mt-4", children: "Please enter the data as you would like it be shown on donor tax receipts" }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Charity Name" }),
      /* @__PURE__ */ t(
        f,
        {
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.name,
          ...o.register("name", { required: "Please enter the charity name" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (u = o.formState.errors.name) == null ? void 0 : u.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Charity Address" }),
      /* @__PURE__ */ t(
        ee,
        {
          variant: "sz",
          rows: 3,
          className: "flex-1",
          invalid: !!o.formState.errors.address,
          ...o.register("address", {
            required: "Please enter the charity address",
            validate: (h) => l(h)
          })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (g = o.formState.errors.address) == null ? void 0 : g.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Email" }),
      /* @__PURE__ */ t(
        f,
        {
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.email,
          ...o.register("email", { required: "Please enter the email" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (m = o.formState.errors.email) == null ? void 0 : m.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Phone Number" }),
      /* @__PURE__ */ t(
        f,
        {
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.phone_number,
          ...o.register("phone_number", { required: "Please enter the phone number" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (b = o.formState.errors.phone_number) == null ? void 0 : b.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Registration Number" }),
      /* @__PURE__ */ t(
        f,
        {
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.registration_number,
          ...o.register("registration_number", { required: "Please enter the charity registration number" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (V = o.formState.errors.registration_number) == null ? void 0 : V.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Representative Name" }),
      /* @__PURE__ */ t(
        f,
        {
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.representative_name,
          ...o.register("representative_name", { required: "Please enter the representative name" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (G = o.formState.errors.representative_name) == null ? void 0 : G.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Footer" }),
      /* @__PURE__ */ t(
        ee,
        {
          variant: "sz",
          rows: 2,
          className: "flex-1",
          invalid: !!o.formState.errors.footer,
          ...o.register("footer", { required: "Please enter the footer" })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (z = o.formState.errors.footer) == null ? void 0 : z.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Logo (jpeg 300x300)" }),
      /* @__PURE__ */ t(
        f,
        {
          type: "file",
          accept: "image/jpeg",
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.logo_image,
          ...o.register("logo_image", {
            required: "Please upload the charity logo",
            validate: async (h) => d(h, tt)
          })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (Z = o.formState.errors.logo_image) == null ? void 0 : Z.message }),
    /* @__PURE__ */ s("label", { className: "flex flex-wrap items-center mt-4", children: [
      /* @__PURE__ */ t("div", { className: "w-full sm:w-36", children: "Signature (jpeg 250x100)" }),
      /* @__PURE__ */ t(
        f,
        {
          type: "file",
          accept: "image/jpeg",
          variant: "sz",
          className: "flex-1",
          invalid: !!o.formState.errors.signature_image,
          ...o.register("signature_image", {
            required: "Please upload the signature image",
            validate: async (h) => d(h, ot)
          })
        }
      )
    ] }),
    /* @__PURE__ */ t("p", { className: "mt-2 text-xs text-right text-sz-pink", children: (p = o.formState.errors.signature_image) == null ? void 0 : p.message }),
    /* @__PURE__ */ t("div", { className: "my-6 underline", children: /* @__PURE__ */ t("a", { onClick: async () => i(), children: "Download tax receipt preview" }) }),
    /* @__PURE__ */ t("hr", { className: "my-4" }),
    /* @__PURE__ */ t("div", { className: "text-right", children: /* @__PURE__ */ t(W, { loading: a.isLoading, disabled: a.isLoading, type: "submit", variant: "sz-primary", children: "SAVE" }) })
  ] });
}, ro = (e) => /* @__PURE__ */ s(me, { className: "bg-white", onClick: e.onClick, children: [
  /* @__PURE__ */ t("h2", { className: "font-mono font-bold text-sz-gray-700", children: e.title }),
  /* @__PURE__ */ t("hr", { className: "mt-4" }),
  /* @__PURE__ */ t("p", { className: "mt-4", children: e.text }),
  /* @__PURE__ */ t("div", { className: "mt-auto text-right", children: /* @__PURE__ */ t(W, { variant: "sz-outline", children: e.buttonText }) })
] }), no = (e) => /* @__PURE__ */ s(me, { className: "bg-white", onClick: e.onClick, children: [
  /* @__PURE__ */ t("h2", { className: "font-mono font-bold text-sz-gray-700", children: e.title }),
  /* @__PURE__ */ t("hr", { className: "mt-4" }),
  /* @__PURE__ */ t(
    Ye,
    {
      isCompleted: e.isCompleted
    }
  ),
  /* @__PURE__ */ t("p", { className: "mt-4", children: e.text }),
  /* @__PURE__ */ t("div", { className: "mt-auto text-right", children: /* @__PURE__ */ t(W, { "data-test-id": e.buttonTestId, variant: e.isCompleted ? "sz-outline" : "sz-primary", children: e.isCompleted ? "EDIT" : "COMPLETE" }) })
] });
export {
  At as ArrowRight,
  vt as AuthenticatedRoute,
  W as Button,
  ro as ButtonCard,
  kt as Check,
  v as ChevronDown,
  F as ChevronDownSmall,
  Lt as ChevronUp,
  Bt as CircleArrowRight,
  Ve as CircleChecked,
  Ye as CircleCompletion,
  zt as CircleCrossed,
  Ge as CircleExclamation,
  Pt as CountryFlagSelection,
  $t as CountrySelection,
  Ct as CreditCard,
  Nt as CreditCard2,
  no as EditCompleteCard,
  Ft as EmailInput,
  Mt as EmailXL,
  Rt as ErrorBoundary,
  Vt as GiftAid,
  me as HoverableCard,
  ue as Input,
  ce as InputInvalidStyles,
  le as InputValidStyles,
  N as InputVariantEnum,
  de as InputVariantStyles,
  f as InputWithRef,
  Gt as LoginForm,
  Ht as Modal,
  _t as Page,
  jt as PageViewEvents,
  Dt as PhoneInputControlled,
  Ut as PhoneInputWithRef,
  St as PhoneXL,
  Wt as ProgressBar,
  Kt as RadioButton,
  Ot as ReusableModal,
  qt as ScrollToTop,
  Tt as SearchIcon,
  ie as Select,
  Et as SelectWithRef,
  Ze as Spinner,
  Yt as TabHeader,
  Jt as TabPanel,
  Xt as Table,
  Qt as TaxDeductibleDisclaimer,
  oo as TaxReceipts,
  eo as TextArea,
  ee as TextAreaWithRef,
  qe as VARIANT_STYLES,
  D as Validate,
  se as Variant,
  to as WithStripeSetup,
  It as causeIcons,
  Je as closeIcon,
  wt as countryCodes,
  w as countryNames,
  Ie as createFakeFileList,
  Q as getFileList,
  Ee as getTaxReceiptsImageUploadUrls,
  Zt as infoIcon,
  P as isFake,
  Re as previewTaxReceiptsData,
  $e as sanitizeSVGFile,
  ft as saveTaxReceiptsData,
  K as uploadImage,
  xt as uploadImageBase64,
  Fe as uploadTaxReceiptImages
};
